// Generated from Logo.g4 by ANTLR 4.5.2
// jshint ignore: start
var antlr4 = require('antlr4/index');
var LogoListener = require('./LogoListener').LogoListener;
var LogoVisitor = require('./LogoVisitor').LogoVisitor;

var grammarFileName = "Logo.g4";

var serializedATN = ["\u0003\u0430\ud6d1\u8206\uad2d\u4417\uaef1\u8d80\uaadd",
    "\u0003v\u021b\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004\u0004\t",
    "\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t\u0007\u0004",
    "\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004\f\t\f\u0004",
    "\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010\t\u0010\u0004",
    "\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013\u0004\u0014\t",
    "\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017\t\u0017\u0004",
    "\u0018\t\u0018\u0004\u0019\t\u0019\u0004\u001a\t\u001a\u0004\u001b\t",
    "\u001b\u0004\u001c\t\u001c\u0004\u001d\t\u001d\u0004\u001e\t\u001e\u0004",
    "\u001f\t\u001f\u0004 \t \u0004!\t!\u0004\"\t\"\u0004#\t#\u0004$\t$\u0004",
    "%\t%\u0004&\t&\u0004\'\t\'\u0004(\t(\u0004)\t)\u0004*\t*\u0004+\t+\u0004",
    ",\t,\u0004-\t-\u0004.\t.\u0004/\t/\u00040\t0\u00041\t1\u00042\t2\u0004",
    "3\t3\u00044\t4\u00045\t5\u00046\t6\u00047\t7\u00048\t8\u00049\t9\u0004",
    ":\t:\u0004;\t;\u0004<\t<\u0004=\t=\u0004>\t>\u0004?\t?\u0004@\t@\u0004",
    "A\tA\u0004B\tB\u0004C\tC\u0004D\tD\u0004E\tE\u0004F\tF\u0004G\tG\u0004",
    "H\tH\u0004I\tI\u0004J\tJ\u0003\u0002\u0005\u0002\u0096\n\u0002\u0003",
    "\u0002\u0006\u0002\u0099\n\u0002\r\u0002\u000e\u0002\u009a\u0003\u0002",
    "\u0005\u0002\u009e\n\u0002\u0003\u0003\u0006\u0003\u00a1\n\u0003\r\u0003",
    "\u000e\u0003\u00a2\u0003\u0003\u0005\u0003\u00a6\n\u0003\u0003\u0003",
    "\u0003\u0003\u0003\u0003\u0005\u0003\u00ab\n\u0003\u0005\u0003\u00ad",
    "\n\u0003\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004",
    "\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004",
    "\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004",
    "\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004",
    "\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004",
    "\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004",
    "\u0003\u0004\u0005\u0004\u00d3\n\u0004\u0003\u0005\u0003\u0005\u0003",
    "\u0005\u0003\u0005\u0003\u0005\u0007\u0005\u00da\n\u0005\f\u0005\u000e",
    "\u0005\u00dd\u000b\u0005\u0003\u0006\u0003\u0006\u0003\u0006\u0007\u0006",
    "\u00e2\n\u0006\f\u0006\u000e\u0006\u00e5\u000b\u0006\u0003\u0006\u0003",
    "\u0006\u0005\u0006\u00e9\n\u0006\u0003\u0006\u0007\u0006\u00ec\n\u0006",
    "\f\u0006\u000e\u0006\u00ef\u000b\u0006\u0003\u0006\u0003\u0006\u0003",
    "\u0007\u0003\u0007\u0003\u0007\u0007\u0007\u00f6\n\u0007\f\u0007\u000e",
    "\u0007\u00f9\u000b\u0007\u0003\b\u0003\b\u0003\b\u0003\b\u0003\b\u0003",
    "\b\u0003\b\u0003\b\u0003\b\u0003\b\u0003\b\u0003\b\u0005\b\u0107\n\b",
    "\u0003\t\u0003\t\u0003\t\u0003\t\u0003\n\u0003\n\u0003\n\u0003\n\u0003",
    "\n\u0003\n\u0003\u000b\u0003\u000b\u0007\u000b\u0115\n\u000b\f\u000b",
    "\u000e\u000b\u0118\u000b\u000b\u0003\u000b\u0007\u000b\u011b\n\u000b",
    "\f\u000b\u000e\u000b\u011e\u000b\u000b\u0003\u000b\u0007\u000b\u0121",
    "\n\u000b\f\u000b\u000e\u000b\u0124\u000b\u000b\u0003\u000b\u0003\u000b",
    "\u0003\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003",
    "\f\u0005\f\u0131\n\f\u0003\r\u0003\r\u0003\r\u0003\r\u0003\r\u0005\r",
    "\u0138\n\r\u0005\r\u013a\n\r\u0003\u000e\u0003\u000e\u0003\u000f\u0003",
    "\u000f\u0003\u000f\u0007\u000f\u0141\n\u000f\f\u000f\u000e\u000f\u0144",
    "\u000b\u000f\u0003\u0010\u0003\u0010\u0003\u0010\u0007\u0010\u0149\n",
    "\u0010\f\u0010\u000e\u0010\u014c\u000b\u0010\u0003\u0011\u0005\u0011",
    "\u014f\n\u0011\u0003\u0011\u0003\u0011\u0003\u0012\u0003\u0012\u0003",
    "\u0012\u0005\u0012\u0156\n\u0012\u0003\u0012\u0003\u0012\u0003\u0012",
    "\u0003\u0012\u0003\u0012\u0003\u0012\u0005\u0012\u015e\n\u0012\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0005\u0013\u0163\n\u0013\u0003\u0014",
    "\u0003\u0014\u0003\u0014\u0003\u0015\u0003\u0015\u0003\u0016\u0003\u0016",
    "\u0003\u0016\u0003\u0016\u0003\u0016\u0003\u0016\u0003\u0017\u0003\u0017",
    "\u0003\u0018\u0003\u0018\u0003\u0018\u0003\u0018\u0003\u0019\u0003\u0019",
    "\u0003\u0019\u0003\u0019\u0003\u0019\u0006\u0019\u017b\n\u0019\r\u0019",
    "\u000e\u0019\u017c\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0005",
    "\u0019\u0183\n\u0019\u0003\u001a\u0003\u001a\u0003\u001a\u0007\u001a",
    "\u0188\n\u001a\f\u001a\u000e\u001a\u018b\u000b\u001a\u0003\u001a\u0003",
    "\u001a\u0003\u001b\u0003\u001b\u0003\u001c\u0003\u001c\u0003\u001c\u0003",
    "\u001d\u0003\u001d\u0003\u001d\u0003\u001e\u0003\u001e\u0003\u001e\u0003",
    "\u001f\u0003\u001f\u0003\u001f\u0003 \u0003 \u0003!\u0003!\u0003\"\u0003",
    "\"\u0003#\u0003#\u0003$\u0003$\u0003%\u0003%\u0003&\u0003&\u0003\'\u0003",
    "\'\u0003(\u0003(\u0003)\u0003)\u0003*\u0003*\u0003+\u0003+\u0003+\u0003",
    "+\u0003+\u0003+\u0005+\u01b9\n+\u0003,\u0003,\u0003,\u0003,\u0003,\u0003",
    ",\u0005,\u01c1\n,\u0003-\u0003-\u0003.\u0003.\u0003/\u0003/\u0003/\u0003",
    "/\u00030\u00030\u00030\u00031\u00031\u00031\u00032\u00032\u00032\u0003",
    "3\u00033\u00033\u00034\u00034\u00034\u00035\u00035\u00035\u00036\u0003",
    "6\u00036\u00037\u00037\u00037\u00038\u00038\u00038\u00039\u00039\u0003",
    "9\u0003:\u0003:\u0003:\u0003;\u0003;\u0003;\u0003;\u0003<\u0003<\u0003",
    "<\u0003<\u0003=\u0003=\u0003=\u0003>\u0003>\u0003>\u0003?\u0003?\u0003",
    "@\u0003@\u0003@\u0003A\u0003A\u0003A\u0003B\u0003B\u0003B\u0003C\u0003",
    "C\u0003C\u0003C\u0003C\u0003C\u0005C\u020b\nC\u0003D\u0003D\u0003E\u0003",
    "E\u0003F\u0003F\u0003G\u0003G\u0003H\u0003H\u0003I\u0003I\u0003J\u0003",
    "J\u0003J\u0002\u0002K\u0002\u0004\u0006\b\n\f\u000e\u0010\u0012\u0014",
    "\u0016\u0018\u001a\u001c\u001e \"$&(*,.02468:<>@BDFHJLNPRTVXZ\\^`bd",
    "fhjlnprtvxz|~\u0080\u0082\u0084\u0086\u0088\u008a\u008c\u008e\u0090",
    "\u0092\u0002\u001c\u0003\u0002\u000b\u0010\u0003\u0002\u0011\u0013\u0003",
    "\u0002\u0014\u0016\u0003\u0002\u0011\u0012\u0003\u0002\u0018(\u0003",
    "\u0002*+\u0003\u0002\t\t\u0003\u0002,-\u0003\u0002.0\u0003\u000212\u0003",
    "\u000234\u0003\u000256\u0003\u0002;<\u0003\u0002=>\u0003\u0002?@\u0003",
    "\u0002AB\u0003\u0002CD\u0003\u0002EF\u0003\u0002GH\u0003\u0002IJ\u0003",
    "\u0002PR\u0003\u0002VW\u0003\u0002XY\u0003\u0002Z[\u0003\u0002`a\u0003",
    "\u0002de\u022a\u0002\u0098\u0003\u0002\u0002\u0002\u0004\u00ac\u0003",
    "\u0002\u0002\u0002\u0006\u00d2\u0003\u0002\u0002\u0002\b\u00d4\u0003",
    "\u0002\u0002\u0002\n\u00de\u0003\u0002\u0002\u0002\f\u00f2\u0003\u0002",
    "\u0002\u0002\u000e\u0106\u0003\u0002\u0002\u0002\u0010\u0108\u0003\u0002",
    "\u0002\u0002\u0012\u010c\u0003\u0002\u0002\u0002\u0014\u0112\u0003\u0002",
    "\u0002\u0002\u0016\u0130\u0003\u0002\u0002\u0002\u0018\u0139\u0003\u0002",
    "\u0002\u0002\u001a\u013b\u0003\u0002\u0002\u0002\u001c\u013d\u0003\u0002",
    "\u0002\u0002\u001e\u0145\u0003\u0002\u0002\u0002 \u014e\u0003\u0002",
    "\u0002\u0002\"\u015d\u0003\u0002\u0002\u0002$\u0162\u0003\u0002\u0002",
    "\u0002&\u0164\u0003\u0002\u0002\u0002(\u0167\u0003\u0002\u0002\u0002",
    "*\u0169\u0003\u0002\u0002\u0002,\u016f\u0003\u0002\u0002\u0002.\u0171",
    "\u0003\u0002\u0002\u00020\u0182\u0003\u0002\u0002\u00022\u0184\u0003",
    "\u0002\u0002\u00024\u018e\u0003\u0002\u0002\u00026\u0190\u0003\u0002",
    "\u0002\u00028\u0193\u0003\u0002\u0002\u0002:\u0196\u0003\u0002\u0002",
    "\u0002<\u0199\u0003\u0002\u0002\u0002>\u019c\u0003\u0002\u0002\u0002",
    "@\u019e\u0003\u0002\u0002\u0002B\u01a0\u0003\u0002\u0002\u0002D\u01a2",
    "\u0003\u0002\u0002\u0002F\u01a4\u0003\u0002\u0002\u0002H\u01a6\u0003",
    "\u0002\u0002\u0002J\u01a8\u0003\u0002\u0002\u0002L\u01aa\u0003\u0002",
    "\u0002\u0002N\u01ac\u0003\u0002\u0002\u0002P\u01ae\u0003\u0002\u0002",
    "\u0002R\u01b0\u0003\u0002\u0002\u0002T\u01b8\u0003\u0002\u0002\u0002",
    "V\u01c0\u0003\u0002\u0002\u0002X\u01c2\u0003\u0002\u0002\u0002Z\u01c4",
    "\u0003\u0002\u0002\u0002\\\u01c6\u0003\u0002\u0002\u0002^\u01ca\u0003",
    "\u0002\u0002\u0002`\u01cd\u0003\u0002\u0002\u0002b\u01d0\u0003\u0002",
    "\u0002\u0002d\u01d3\u0003\u0002\u0002\u0002f\u01d6\u0003\u0002\u0002",
    "\u0002h\u01d9\u0003\u0002\u0002\u0002j\u01dc\u0003\u0002\u0002\u0002",
    "l\u01df\u0003\u0002\u0002\u0002n\u01e2\u0003\u0002\u0002\u0002p\u01e5",
    "\u0003\u0002\u0002\u0002r\u01e8\u0003\u0002\u0002\u0002t\u01eb\u0003",
    "\u0002\u0002\u0002v\u01ef\u0003\u0002\u0002\u0002x\u01f3\u0003\u0002",
    "\u0002\u0002z\u01f6\u0003\u0002\u0002\u0002|\u01f9\u0003\u0002\u0002",
    "\u0002~\u01fb\u0003\u0002\u0002\u0002\u0080\u01fe\u0003\u0002\u0002",
    "\u0002\u0082\u0201\u0003\u0002\u0002\u0002\u0084\u020a\u0003\u0002\u0002",
    "\u0002\u0086\u020c\u0003\u0002\u0002\u0002\u0088\u020e\u0003\u0002\u0002",
    "\u0002\u008a\u0210\u0003\u0002\u0002\u0002\u008c\u0212\u0003\u0002\u0002",
    "\u0002\u008e\u0214\u0003\u0002\u0002\u0002\u0090\u0216\u0003\u0002\u0002",
    "\u0002\u0092\u0218\u0003\u0002\u0002\u0002\u0094\u0096\u0005\u0004\u0003",
    "\u0002\u0095\u0094\u0003\u0002\u0002\u0002\u0095\u0096\u0003\u0002\u0002",
    "\u0002\u0096\u0097\u0003\u0002\u0002\u0002\u0097\u0099\u0007u\u0002",
    "\u0002\u0098\u0095\u0003\u0002\u0002\u0002\u0099\u009a\u0003\u0002\u0002",
    "\u0002\u009a\u0098\u0003\u0002\u0002\u0002\u009a\u009b\u0003\u0002\u0002",
    "\u0002\u009b\u009d\u0003\u0002\u0002\u0002\u009c\u009e\u0005\u0004\u0003",
    "\u0002\u009d\u009c\u0003\u0002\u0002\u0002\u009d\u009e\u0003\u0002\u0002",
    "\u0002\u009e\u0003\u0003\u0002\u0002\u0002\u009f\u00a1\u0005\u0006\u0004",
    "\u0002\u00a0\u009f\u0003\u0002\u0002\u0002\u00a1\u00a2\u0003\u0002\u0002",
    "\u0002\u00a2\u00a0\u0003\u0002\u0002\u0002\u00a2\u00a3\u0003\u0002\u0002",
    "\u0002\u00a3\u00a5\u0003\u0002\u0002\u0002\u00a4\u00a6\u0005\u0086D",
    "\u0002\u00a5\u00a4\u0003\u0002\u0002\u0002\u00a5\u00a6\u0003\u0002\u0002",
    "\u0002\u00a6\u00ad\u0003\u0002\u0002\u0002\u00a7\u00ad\u0005\u0086D",
    "\u0002\u00a8\u00aa\u00050\u0019\u0002\u00a9\u00ab\u0005\u0086D\u0002",
    "\u00aa\u00a9\u0003\u0002\u0002\u0002\u00aa\u00ab\u0003\u0002\u0002\u0002",
    "\u00ab\u00ad\u0003\u0002\u0002\u0002\u00ac\u00a0\u0003\u0002\u0002\u0002",
    "\u00ac\u00a7\u0003\u0002\u0002\u0002\u00ac\u00a8\u0003\u0002\u0002\u0002",
    "\u00ad\u0005\u0003\u0002\u0002\u0002\u00ae\u00d3\u0005\u0010\t\u0002",
    "\u00af\u00d3\u00056\u001c\u0002\u00b0\u00d3\u00058\u001d\u0002\u00b1",
    "\u00d3\u0005:\u001e\u0002\u00b2\u00d3\u0005<\u001f\u0002\u00b3\u00d3",
    "\u0005> \u0002\u00b4\u00d3\u0005B\"\u0002\u00b5\u00d3\u0005D#\u0002",
    "\u00b6\u00d3\u0005F$\u0002\u00b7\u00d3\u0005H%\u0002\u00b8\u00d3\u0005",
    "J&\u0002\u00b9\u00d3\u0005P)\u0002\u00ba\u00d3\u0005R*\u0002\u00bb\u00d3",
    "\u0005L\'\u0002\u00bc\u00d3\u0005N(\u0002\u00bd\u00d3\u0005X-\u0002",
    "\u00be\u00d3\u0005^0\u0002\u00bf\u00d3\u0005`1\u0002\u00c0\u00d3\u0005",
    "\\/\u0002\u00c1\u00d3\u0005T+\u0002\u00c2\u00d3\u0005V,\u0002\u00c3",
    "\u00d3\u0005.\u0018\u0002\u00c4\u00d3\u0005\b\u0005\u0002\u00c5\u00d3",
    "\u0005\u0016\f\u0002\u00c6\u00d3\u0005Z.\u0002\u00c7\u00d3\u0005z>\u0002",
    "\u00c8\u00d3\u0005\u0012\n\u0002\u00c9\u00d3\u0005|?\u0002\u00ca\u00d3",
    "\u0005~@\u0002\u00cb\u00d3\u0005\u0080A\u0002\u00cc\u00d3\u0005\u0082",
    "B\u0002\u00cd\u00d3\u00050\u0019\u0002\u00ce\u00d3\u0005\u008cG\u0002",
    "\u00cf\u00d3\u0005\u0092J\u0002\u00d0\u00d3\u0005\u008eH\u0002\u00d1",
    "\u00d3\u0005\u0090I\u0002\u00d2\u00ae\u0003\u0002\u0002\u0002\u00d2",
    "\u00af\u0003\u0002\u0002\u0002\u00d2\u00b0\u0003\u0002\u0002\u0002\u00d2",
    "\u00b1\u0003\u0002\u0002\u0002\u00d2\u00b2\u0003\u0002\u0002\u0002\u00d2",
    "\u00b3\u0003\u0002\u0002\u0002\u00d2\u00b4\u0003\u0002\u0002\u0002\u00d2",
    "\u00b5\u0003\u0002\u0002\u0002\u00d2\u00b6\u0003\u0002\u0002\u0002\u00d2",
    "\u00b7\u0003\u0002\u0002\u0002\u00d2\u00b8\u0003\u0002\u0002\u0002\u00d2",
    "\u00b9\u0003\u0002\u0002\u0002\u00d2\u00ba\u0003\u0002\u0002\u0002\u00d2",
    "\u00bb\u0003\u0002\u0002\u0002\u00d2\u00bc\u0003\u0002\u0002\u0002\u00d2",
    "\u00bd\u0003\u0002\u0002\u0002\u00d2\u00be\u0003\u0002\u0002\u0002\u00d2",
    "\u00bf\u0003\u0002\u0002\u0002\u00d2\u00c0\u0003\u0002\u0002\u0002\u00d2",
    "\u00c1\u0003\u0002\u0002\u0002\u00d2\u00c2\u0003\u0002\u0002\u0002\u00d2",
    "\u00c3\u0003\u0002\u0002\u0002\u00d2\u00c4\u0003\u0002\u0002\u0002\u00d2",
    "\u00c5\u0003\u0002\u0002\u0002\u00d2\u00c6\u0003\u0002\u0002\u0002\u00d2",
    "\u00c7\u0003\u0002\u0002\u0002\u00d2\u00c8\u0003\u0002\u0002\u0002\u00d2",
    "\u00c9\u0003\u0002\u0002\u0002\u00d2\u00ca\u0003\u0002\u0002\u0002\u00d2",
    "\u00cb\u0003\u0002\u0002\u0002\u00d2\u00cc\u0003\u0002\u0002\u0002\u00d2",
    "\u00cd\u0003\u0002\u0002\u0002\u00d2\u00ce\u0003\u0002\u0002\u0002\u00d2",
    "\u00cf\u0003\u0002\u0002\u0002\u00d2\u00d0\u0003\u0002\u0002\u0002\u00d2",
    "\u00d1\u0003\u0002\u0002\u0002\u00d3\u0007\u0003\u0002\u0002\u0002\u00d4",
    "\u00db\u00054\u001b\u0002\u00d5\u00da\u0005\u0018\r\u0002\u00d6\u00da",
    "\u0005*\u0016\u0002\u00d7\u00da\u0005(\u0015\u0002\u00d8\u00da\u0005",
    "2\u001a\u0002\u00d9\u00d5\u0003\u0002\u0002\u0002\u00d9\u00d6\u0003",
    "\u0002\u0002\u0002\u00d9\u00d7\u0003\u0002\u0002\u0002\u00d9\u00d8\u0003",
    "\u0002\u0002\u0002\u00da\u00dd\u0003\u0002\u0002\u0002\u00db\u00d9\u0003",
    "\u0002\u0002\u0002\u00db\u00dc\u0003\u0002\u0002\u0002\u00dc\t\u0003",
    "\u0002\u0002\u0002\u00dd\u00db\u0003\u0002\u0002\u0002\u00de\u00df\u0007",
    "\u0003\u0002\u0002\u00df\u00e3\u00054\u001b\u0002\u00e0\u00e2\u0005",
    "\f\u0007\u0002\u00e1\u00e0\u0003\u0002\u0002\u0002\u00e2\u00e5\u0003",
    "\u0002\u0002\u0002\u00e3\u00e1\u0003\u0002\u0002\u0002\u00e3\u00e4\u0003",
    "\u0002\u0002\u0002\u00e4\u00e6\u0003\u0002\u0002\u0002\u00e5\u00e3\u0003",
    "\u0002\u0002\u0002\u00e6\u00ed\u0007u\u0002\u0002\u00e7\u00e9\u0005",
    "\u0004\u0003\u0002\u00e8\u00e7\u0003\u0002\u0002\u0002\u00e8\u00e9\u0003",
    "\u0002\u0002\u0002\u00e9\u00ea\u0003\u0002\u0002\u0002\u00ea\u00ec\u0007",
    "u\u0002\u0002\u00eb\u00e8\u0003\u0002\u0002\u0002\u00ec\u00ef\u0003",
    "\u0002\u0002\u0002\u00ed\u00eb\u0003\u0002\u0002\u0002\u00ed\u00ee\u0003",
    "\u0002\u0002\u0002\u00ee\u00f0\u0003\u0002\u0002\u0002\u00ef\u00ed\u0003",
    "\u0002\u0002\u0002\u00f0\u00f1\u0007\u0004\u0002\u0002\u00f1\u000b\u0003",
    "\u0002\u0002\u0002\u00f2\u00f3\u0007\u0005\u0002\u0002\u00f3\u00f7\u0005",
    "4\u001b\u0002\u00f4\u00f6\u0005\f\u0007\u0002\u00f5\u00f4\u0003\u0002",
    "\u0002\u0002\u00f6\u00f9\u0003\u0002\u0002\u0002\u00f7\u00f5\u0003\u0002",
    "\u0002\u0002\u00f7\u00f8\u0003\u0002\u0002\u0002\u00f8\r\u0003\u0002",
    "\u0002\u0002\u00f9\u00f7\u0003\u0002\u0002\u0002\u00fa\u0107\u0005b",
    "2\u0002\u00fb\u0107\u0005d3\u0002\u00fc\u0107\u0005f4\u0002\u00fd\u0107",
    "\u0005h5\u0002\u00fe\u0107\u0005j6\u0002\u00ff\u0107\u0005l7\u0002\u0100",
    "\u0107\u0005n8\u0002\u0101\u0107\u0005p9\u0002\u0102\u0107\u0005r:\u0002",
    "\u0103\u0107\u0005t;\u0002\u0104\u0107\u0005v<\u0002\u0105\u0107\u0005",
    "x=\u0002\u0106\u00fa\u0003\u0002\u0002\u0002\u0106\u00fb\u0003\u0002",
    "\u0002\u0002\u0106\u00fc\u0003\u0002\u0002\u0002\u0106\u00fd\u0003\u0002",
    "\u0002\u0002\u0106\u00fe\u0003\u0002\u0002\u0002\u0106\u00ff\u0003\u0002",
    "\u0002\u0002\u0106\u0100\u0003\u0002\u0002\u0002\u0106\u0101\u0003\u0002",
    "\u0002\u0002\u0106\u0102\u0003\u0002\u0002\u0002\u0106\u0103\u0003\u0002",
    "\u0002\u0002\u0106\u0104\u0003\u0002\u0002\u0002\u0106\u0105\u0003\u0002",
    "\u0002\u0002\u0107\u000f\u0003\u0002\u0002\u0002\u0108\u0109\u0007\u0006",
    "\u0002\u0002\u0109\u010a\u0005\u0018\r\u0002\u010a\u010b\u0005\u0014",
    "\u000b\u0002\u010b\u0011\u0003\u0002\u0002\u0002\u010c\u010d\u0007\u0007",
    "\u0002\u0002\u010d\u010e\u0007\b\u0002\u0002\u010e\u010f\u0005\u0018",
    "\r\u0002\u010f\u0110\u0007\t\u0002\u0002\u0110\u0111\u0005\u0014\u000b",
    "\u0002\u0111\u0013\u0003\u0002\u0002\u0002\u0112\u0116\u0007\b\u0002",
    "\u0002\u0113\u0115\u0007u\u0002\u0002\u0114\u0113\u0003\u0002\u0002",
    "\u0002\u0115\u0118\u0003\u0002\u0002\u0002\u0116\u0114\u0003\u0002\u0002",
    "\u0002\u0116\u0117\u0003\u0002\u0002\u0002\u0117\u011c\u0003\u0002\u0002",
    "\u0002\u0118\u0116\u0003\u0002\u0002\u0002\u0119\u011b\u0005\u0006\u0004",
    "\u0002\u011a\u0119\u0003\u0002\u0002\u0002\u011b\u011e\u0003\u0002\u0002",
    "\u0002\u011c\u011a\u0003\u0002\u0002\u0002\u011c\u011d\u0003\u0002\u0002",
    "\u0002\u011d\u0122\u0003\u0002\u0002\u0002\u011e\u011c\u0003\u0002\u0002",
    "\u0002\u011f\u0121\u0007u\u0002\u0002\u0120\u011f\u0003\u0002\u0002",
    "\u0002\u0121\u0124\u0003\u0002\u0002\u0002\u0122\u0120\u0003\u0002\u0002",
    "\u0002\u0122\u0123\u0003\u0002\u0002\u0002\u0123\u0125\u0003\u0002\u0002",
    "\u0002\u0124\u0122\u0003\u0002\u0002\u0002\u0125\u0126\u0007\t\u0002",
    "\u0002\u0126\u0015\u0003\u0002\u0002\u0002\u0127\u0128\u0007\n\u0002",
    "\u0002\u0128\u0129\u0005\u0018\r\u0002\u0129\u012a\u0005\u0014\u000b",
    "\u0002\u012a\u0131\u0003\u0002\u0002\u0002\u012b\u012c\u0007\n\u0002",
    "\u0002\u012c\u012d\u0005\u0018\r\u0002\u012d\u012e\u0005\u0014\u000b",
    "\u0002\u012e\u012f\u0005\u0014\u000b\u0002\u012f\u0131\u0003\u0002\u0002",
    "\u0002\u0130\u0127\u0003\u0002\u0002\u0002\u0130\u012b\u0003\u0002\u0002",
    "\u0002\u0131\u0017\u0003\u0002\u0002\u0002\u0132\u013a\u0005\u0084C",
    "\u0002\u0133\u0137\u0005\u001c\u000f\u0002\u0134\u0135\u0005\u001a\u000e",
    "\u0002\u0135\u0136\u0005\u001c\u000f\u0002\u0136\u0138\u0003\u0002\u0002",
    "\u0002\u0137\u0134\u0003\u0002\u0002\u0002\u0137\u0138\u0003\u0002\u0002",
    "\u0002\u0138\u013a\u0003\u0002\u0002\u0002\u0139\u0132\u0003\u0002\u0002",
    "\u0002\u0139\u0133\u0003\u0002\u0002\u0002\u013a\u0019\u0003\u0002\u0002",
    "\u0002\u013b\u013c\t\u0002\u0002\u0002\u013c\u001b\u0003\u0002\u0002",
    "\u0002\u013d\u0142\u0005\u001e\u0010\u0002\u013e\u013f\t\u0003\u0002",
    "\u0002\u013f\u0141\u0005\u001e\u0010\u0002\u0140\u013e\u0003\u0002\u0002",
    "\u0002\u0141\u0144\u0003\u0002\u0002\u0002\u0142\u0140\u0003\u0002\u0002",
    "\u0002\u0142\u0143\u0003\u0002\u0002\u0002\u0143\u001d\u0003\u0002\u0002",
    "\u0002\u0144\u0142\u0003\u0002\u0002\u0002\u0145\u014a\u0005 \u0011",
    "\u0002\u0146\u0147\t\u0004\u0002\u0002\u0147\u0149\u0005 \u0011\u0002",
    "\u0148\u0146\u0003\u0002\u0002\u0002\u0149\u014c\u0003\u0002\u0002\u0002",
    "\u014a\u0148\u0003\u0002\u0002\u0002\u014a\u014b\u0003\u0002\u0002\u0002",
    "\u014b\u001f\u0003\u0002\u0002\u0002\u014c\u014a\u0003\u0002\u0002\u0002",
    "\u014d\u014f\t\u0005\u0002\u0002\u014e\u014d\u0003\u0002\u0002\u0002",
    "\u014e\u014f\u0003\u0002\u0002\u0002\u014f\u0150\u0003\u0002\u0002\u0002",
    "\u0150\u0151\u0005\"\u0012\u0002\u0151!\u0003\u0002\u0002\u0002\u0152",
    "\u0156\u0005\u0084C\u0002\u0153\u0156\u0005&\u0014\u0002\u0154\u0156",
    "\u0005\u000e\b\u0002\u0155\u0152\u0003\u0002\u0002\u0002\u0155\u0153",
    "\u0003\u0002\u0002\u0002\u0155\u0154\u0003\u0002\u0002\u0002\u0156\u015e",
    "\u0003\u0002\u0002\u0002\u0157\u0158\u0007q\u0002\u0002\u0158\u0159",
    "\u0005\u0018\r\u0002\u0159\u015a\u0007r\u0002\u0002\u015a\u015e\u0003",
    "\u0002\u0002\u0002\u015b\u015c\u0007\u0017\u0002\u0002\u015c\u015e\u0005",
    " \u0011\u0002\u015d\u0155\u0003\u0002\u0002\u0002\u015d\u0157\u0003",
    "\u0002\u0002\u0002\u015d\u015b\u0003\u0002\u0002\u0002\u015e#\u0003",
    "\u0002\u0002\u0002\u015f\u0163\u0007o\u0002\u0002\u0160\u0163\u0005",
    "\u0018\r\u0002\u0161\u0163\u0005&\u0014\u0002\u0162\u015f\u0003\u0002",
    "\u0002\u0002\u0162\u0160\u0003\u0002\u0002\u0002\u0162\u0161\u0003\u0002",
    "\u0002\u0002\u0163%\u0003\u0002\u0002\u0002\u0164\u0165\u0007\u0005",
    "\u0002\u0002\u0165\u0166\u00054\u001b\u0002\u0166\'\u0003\u0002\u0002",
    "\u0002\u0167\u0168\t\u0006\u0002\u0002\u0168)\u0003\u0002\u0002\u0002",
    "\u0169\u016a\u0007\b\u0002\u0002\u016a\u016b\u0005\u0018\r\u0002\u016b",
    "\u016c\u0005\u0018\r\u0002\u016c\u016d\u0005\u0018\r\u0002\u016d\u016e",
    "\u0007\t\u0002\u0002\u016e+\u0003\u0002\u0002\u0002\u016f\u0170\u0005",
    "\u0018\r\u0002\u0170-\u0003\u0002\u0002\u0002\u0171\u0172\u0007)\u0002",
    "\u0002\u0172\u0173\u0007o\u0002\u0002\u0173\u0174\u0005$\u0013\u0002",
    "\u0174/\u0003\u0002\u0002\u0002\u0175\u0176\t\u0007\u0002\u0002\u0176",
    "\u0183\u0005$\u0013\u0002\u0177\u0178\t\u0007\u0002\u0002\u0178\u017a",
    "\u0007\b\u0002\u0002\u0179\u017b\u0005$\u0013\u0002\u017a\u0179\u0003",
    "\u0002\u0002\u0002\u017b\u017c\u0003\u0002\u0002\u0002\u017c\u017a\u0003",
    "\u0002\u0002\u0002\u017c\u017d\u0003\u0002\u0002\u0002\u017d\u017e\u0003",
    "\u0002\u0002\u0002\u017e\u017f\u0007\t\u0002\u0002\u017f\u0183\u0003",
    "\u0002\u0002\u0002\u0180\u0181\t\u0007\u0002\u0002\u0181\u0183\u0005",
    "2\u001a\u0002\u0182\u0175\u0003\u0002\u0002\u0002\u0182\u0177\u0003",
    "\u0002\u0002\u0002\u0182\u0180\u0003\u0002\u0002\u0002\u01831\u0003",
    "\u0002\u0002\u0002\u0184\u0189\u0007\b\u0002\u0002\u0185\u0188\u0005",
    "2\u001a\u0002\u0186\u0188\n\b\u0002\u0002\u0187\u0185\u0003\u0002\u0002",
    "\u0002\u0187\u0186\u0003\u0002\u0002\u0002\u0188\u018b\u0003\u0002\u0002",
    "\u0002\u0189\u0187\u0003\u0002\u0002\u0002\u0189\u018a\u0003\u0002\u0002",
    "\u0002\u018a\u018c\u0003\u0002\u0002\u0002\u018b\u0189\u0003\u0002\u0002",
    "\u0002\u018c\u018d\u0007\t\u0002\u0002\u018d3\u0003\u0002\u0002\u0002",
    "\u018e\u018f\u0007p\u0002\u0002\u018f5\u0003\u0002\u0002\u0002\u0190",
    "\u0191\t\t\u0002\u0002\u0191\u0192\u0005\u0018\r\u0002\u01927\u0003",
    "\u0002\u0002\u0002\u0193\u0194\t\n\u0002\u0002\u0194\u0195\u0005\u0018",
    "\r\u0002\u01959\u0003\u0002\u0002\u0002\u0196\u0197\t\u000b\u0002\u0002",
    "\u0197\u0198\u0005\u0018\r\u0002\u0198;\u0003\u0002\u0002\u0002\u0199",
    "\u019a\t\f\u0002\u0002\u019a\u019b\u0005\u0018\r\u0002\u019b=\u0003",
    "\u0002\u0002\u0002\u019c\u019d\t\r\u0002\u0002\u019d?\u0003\u0002\u0002",
    "\u0002\u019e\u019f\u00077\u0002\u0002\u019fA\u0003\u0002\u0002\u0002",
    "\u01a0\u01a1\u00078\u0002\u0002\u01a1C\u0003\u0002\u0002\u0002\u01a2",
    "\u01a3\u00079\u0002\u0002\u01a3E\u0003\u0002\u0002\u0002\u01a4\u01a5",
    "\u0007:\u0002\u0002\u01a5G\u0003\u0002\u0002\u0002\u01a6\u01a7\t\u000e",
    "\u0002\u0002\u01a7I\u0003\u0002\u0002\u0002\u01a8\u01a9\t\u000f\u0002",
    "\u0002\u01a9K\u0003\u0002\u0002\u0002\u01aa\u01ab\t\u0010\u0002\u0002",
    "\u01abM\u0003\u0002\u0002\u0002\u01ac\u01ad\t\u0011\u0002\u0002\u01ad",
    "O\u0003\u0002\u0002\u0002\u01ae\u01af\t\u0012\u0002\u0002\u01afQ\u0003",
    "\u0002\u0002\u0002\u01b0\u01b1\t\u0013\u0002\u0002\u01b1S\u0003\u0002",
    "\u0002\u0002\u01b2\u01b3\t\u0014\u0002\u0002\u01b3\u01b9\u0005,\u0017",
    "\u0002\u01b4\u01b5\t\u0014\u0002\u0002\u01b5\u01b9\u0005*\u0016\u0002",
    "\u01b6\u01b7\t\u0014\u0002\u0002\u01b7\u01b9\u0005(\u0015\u0002\u01b8",
    "\u01b2\u0003\u0002\u0002\u0002\u01b8\u01b4\u0003\u0002\u0002\u0002\u01b8",
    "\u01b6\u0003\u0002\u0002\u0002\u01b9U\u0003\u0002\u0002\u0002\u01ba",
    "\u01bb\t\u0015\u0002\u0002\u01bb\u01c1\u0005*\u0016\u0002\u01bc\u01bd",
    "\t\u0015\u0002\u0002\u01bd\u01c1\u0005(\u0015\u0002\u01be\u01bf\t\u0015",
    "\u0002\u0002\u01bf\u01c1\u0005,\u0017\u0002\u01c0\u01ba\u0003\u0002",
    "\u0002\u0002\u01c0\u01bc\u0003\u0002\u0002\u0002\u01c0\u01be\u0003\u0002",
    "\u0002\u0002\u01c1W\u0003\u0002\u0002\u0002\u01c2\u01c3\u0007K\u0002",
    "\u0002\u01c3Y\u0003\u0002\u0002\u0002\u01c4\u01c5\u0007L\u0002\u0002",
    "\u01c5[\u0003\u0002\u0002\u0002\u01c6\u01c7\u0007M\u0002\u0002\u01c7",
    "\u01c8\u0005\u0018\r\u0002\u01c8\u01c9\u0005\u0018\r\u0002\u01c9]\u0003",
    "\u0002\u0002\u0002\u01ca\u01cb\u0007N\u0002\u0002\u01cb\u01cc\u0005",
    "\u0018\r\u0002\u01cc_\u0003\u0002\u0002\u0002\u01cd\u01ce\u0007O\u0002",
    "\u0002\u01ce\u01cf\u0005\u0018\r\u0002\u01cfa\u0003\u0002\u0002\u0002",
    "\u01d0\u01d1\t\u0016\u0002\u0002\u01d1\u01d2\u0005\u0018\r\u0002\u01d2",
    "c\u0003\u0002\u0002\u0002\u01d3\u01d4\u0007S\u0002\u0002\u01d4\u01d5",
    "\u0005\u0018\r\u0002\u01d5e\u0003\u0002\u0002\u0002\u01d6\u01d7\u0007",
    "T\u0002\u0002\u01d7\u01d8\u0005\u0018\r\u0002\u01d8g\u0003\u0002\u0002",
    "\u0002\u01d9\u01da\u0007U\u0002\u0002\u01da\u01db\u0005\u0018\r\u0002",
    "\u01dbi\u0003\u0002\u0002\u0002\u01dc\u01dd\t\u0017\u0002\u0002\u01dd",
    "\u01de\u0005\u0018\r\u0002\u01dek\u0003\u0002\u0002\u0002\u01df\u01e0",
    "\t\u0018\u0002\u0002\u01e0\u01e1\u0005\u0018\r\u0002\u01e1m\u0003\u0002",
    "\u0002\u0002\u01e2\u01e3\t\u0019\u0002\u0002\u01e3\u01e4\u0005\u0018",
    "\r\u0002\u01e4o\u0003\u0002\u0002\u0002\u01e5\u01e6\u0007\\\u0002\u0002",
    "\u01e6\u01e7\u0005\u0018\r\u0002\u01e7q\u0003\u0002\u0002\u0002\u01e8",
    "\u01e9\u0007]\u0002\u0002\u01e9\u01ea\u0005\u0018\r\u0002\u01eas\u0003",
    "\u0002\u0002\u0002\u01eb\u01ec\u0007^\u0002\u0002\u01ec\u01ed\u0005",
    "\u0018\r\u0002\u01ed\u01ee\u0005\u0018\r\u0002\u01eeu\u0003\u0002\u0002",
    "\u0002\u01ef\u01f0\u0007_\u0002\u0002\u01f0\u01f1\u0005\u0018\r\u0002",
    "\u01f1\u01f2\u0005\u0018\r\u0002\u01f2w\u0003\u0002\u0002\u0002\u01f3",
    "\u01f4\t\u001a\u0002\u0002\u01f4\u01f5\u0005\u0018\r\u0002\u01f5y\u0003",
    "\u0002\u0002\u0002\u01f6\u01f7\u0007b\u0002\u0002\u01f7\u01f8\u0005",
    "\u0018\r\u0002\u01f8{\u0003\u0002\u0002\u0002\u01f9\u01fa\u0007c\u0002",
    "\u0002\u01fa}\u0003\u0002\u0002\u0002\u01fb\u01fc\t\u001b\u0002\u0002",
    "\u01fc\u01fd\u0005\u0018\r\u0002\u01fd\u007f\u0003\u0002\u0002\u0002",
    "\u01fe\u01ff\u0007f\u0002\u0002\u01ff\u0200\u0005\u0018\r\u0002\u0200",
    "\u0081\u0003\u0002\u0002\u0002\u0201\u0202\u0007g\u0002\u0002\u0202",
    "\u0203\u0005\u0018\r\u0002\u0203\u0083\u0003\u0002\u0002\u0002\u0204",
    "\u020b\u0007s\u0002\u0002\u0205\u0206\u0007s\u0002\u0002\u0206\u0207",
    "\u0007h\u0002\u0002\u0207\u020b\u0007s\u0002\u0002\u0208\u020b\u0005",
    "\u0088E\u0002\u0209\u020b\u0005\u008aF\u0002\u020a\u0204\u0003\u0002",
    "\u0002\u0002\u020a\u0205\u0003\u0002\u0002\u0002\u020a\u0208\u0003\u0002",
    "\u0002\u0002\u020a\u0209\u0003\u0002\u0002\u0002\u020b\u0085\u0003\u0002",
    "\u0002\u0002\u020c\u020d\u0007t\u0002\u0002\u020d\u0087\u0003\u0002",
    "\u0002\u0002\u020e\u020f\u0007i\u0002\u0002\u020f\u0089\u0003\u0002",
    "\u0002\u0002\u0210\u0211\u0007j\u0002\u0002\u0211\u008b\u0003\u0002",
    "\u0002\u0002\u0212\u0213\u0007k\u0002\u0002\u0213\u008d\u0003\u0002",
    "\u0002\u0002\u0214\u0215\u0007l\u0002\u0002\u0215\u008f\u0003\u0002",
    "\u0002\u0002\u0216\u0217\u0007m\u0002\u0002\u0217\u0091\u0003\u0002",
    "\u0002\u0002\u0218\u0219\u0007n\u0002\u0002\u0219\u0093\u0003\u0002",
    "\u0002\u0002$\u0095\u009a\u009d\u00a2\u00a5\u00aa\u00ac\u00d2\u00d9",
    "\u00db\u00e3\u00e8\u00ed\u00f7\u0106\u0116\u011c\u0122\u0130\u0137\u0139",
    "\u0142\u014a\u014e\u0155\u015d\u0162\u017c\u0182\u0187\u0189\u01b8\u01c0",
    "\u020a"].join("");


var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map( function(ds, index) { return new antlr4.dfa.DFA(ds, index); });

var sharedContextCache = new antlr4.PredictionContextCache();

var literalNames = [ null, "'to'", "'end'", "':'", "'repeat'", "'while'", 
                     "'['", "']'", "'if'", "'<'", "'>'", "'='", "'<='", 
                     "'>='", "'!='", "'+'", "'-'", "'||'", "'*'", "'/'", 
                     "'&&'", "'!'", "'black'", "'red'", "'green'", "'yellow'", 
                     "'blue'", "'magenta'", "'cyan'", "'white'", "'gray'", 
                     "'lightgray'", "'darkred'", "'darkgreen'", "'darkblue'", 
                     "'orange'", "'pink'", "'purple'", "'brown'", "'make'", 
                     "'print'", "'pr'", "'fd'", "'forward'", "'bk'", "'back'", 
                     "'backward'", "'rt'", "'right'", "'lt'", "'left'", 
                     "'cs'", "'clearscreen'", "'retry'", "'next'", "'last'", 
                     "'ct'", "'pu'", "'penup'", "'pd'", "'pendown'", "'pe'", 
                     "'penerase'", "'ppt'", "'penpaint'", "'ht'", "'hideturtle'", 
                     "'st'", "'showturtle'", "'setpc'", "'setpencolor'", 
                     "'setsc'", "'setscreencolor'", "'home'", "'stop'", 
                     "'setxy'", "'setx'", "'sety'", "'random'", "'rnd'", 
                     "'ran'", "'sin'", "'cos'", "'tan'", "'arcsin'", "'asin'", 
                     "'arccos'", "'acos'", "'arctan'", "'atan'", "'abs'", 
                     "'sqrt'", "'mod'", "'power'", "'log'", "'log10'", "'wait'", 
                     "'wash'", "'setpw'", "'setpenwidth'", "'circle'", "'setheading'", 
                     "'.'", "'pi'", "'e'", "'unittest'", "'createtestcase'", 
                     "'generatesolutions'", "'unittestbook'", null, null, 
                     "'('", "')'" ];

var symbolicNames = [ null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, "STRINGLITERAL", "STRING", "LPAREN", "RPAREN", 
                      "NUMBER", "COMMENT", "EOL", "WS" ];

var ruleNames =  [ "prog", "line", "cmd", "procedureInvocation", "procedureDeclaration", 
                   "parameterDeclarations", "func", "repeat", "whilee", 
                   "block", "ife", "expression", "comparisonOperator", "sExpr", 
                   "term", "factor", "nsFact", "value", "deref", "colorname", 
                   "rgb", "colornumber", "make", "print", "quotedstring", 
                   "name", "fd", "bk", "rt", "lt", "cs", "retry", "next", 
                   "last", "ct", "pu", "pd", "pe", "ppt", "ht", "st", "setpc", 
                   "setsc", "home", "stop", "setxy", "setx", "sety", "random", 
                   "sin", "cos", "tan", "arcsin", "arccos", "arctan", "abs", 
                   "sqrt", "mod", "power", "log10", "waite", "wash", "setpw", 
                   "circle", "setheading", "number", "comment", "pie", "ee", 
                   "unitTest", "createTestCase", "generateSolutions", "unitTestBook" ];

function LogoParser (input) {
	antlr4.Parser.call(this, input);
    this._interp = new antlr4.atn.ParserATNSimulator(this, atn, decisionsToDFA, sharedContextCache);
    this.ruleNames = ruleNames;
    this.literalNames = literalNames;
    this.symbolicNames = symbolicNames;
    return this;
}

LogoParser.prototype = Object.create(antlr4.Parser.prototype);
LogoParser.prototype.constructor = LogoParser;

Object.defineProperty(LogoParser.prototype, "atn", {
	get : function() {
		return atn;
	}
});

LogoParser.EOF = antlr4.Token.EOF;
LogoParser.T__0 = 1;
LogoParser.T__1 = 2;
LogoParser.T__2 = 3;
LogoParser.T__3 = 4;
LogoParser.T__4 = 5;
LogoParser.T__5 = 6;
LogoParser.T__6 = 7;
LogoParser.T__7 = 8;
LogoParser.T__8 = 9;
LogoParser.T__9 = 10;
LogoParser.T__10 = 11;
LogoParser.T__11 = 12;
LogoParser.T__12 = 13;
LogoParser.T__13 = 14;
LogoParser.T__14 = 15;
LogoParser.T__15 = 16;
LogoParser.T__16 = 17;
LogoParser.T__17 = 18;
LogoParser.T__18 = 19;
LogoParser.T__19 = 20;
LogoParser.T__20 = 21;
LogoParser.T__21 = 22;
LogoParser.T__22 = 23;
LogoParser.T__23 = 24;
LogoParser.T__24 = 25;
LogoParser.T__25 = 26;
LogoParser.T__26 = 27;
LogoParser.T__27 = 28;
LogoParser.T__28 = 29;
LogoParser.T__29 = 30;
LogoParser.T__30 = 31;
LogoParser.T__31 = 32;
LogoParser.T__32 = 33;
LogoParser.T__33 = 34;
LogoParser.T__34 = 35;
LogoParser.T__35 = 36;
LogoParser.T__36 = 37;
LogoParser.T__37 = 38;
LogoParser.T__38 = 39;
LogoParser.T__39 = 40;
LogoParser.T__40 = 41;
LogoParser.T__41 = 42;
LogoParser.T__42 = 43;
LogoParser.T__43 = 44;
LogoParser.T__44 = 45;
LogoParser.T__45 = 46;
LogoParser.T__46 = 47;
LogoParser.T__47 = 48;
LogoParser.T__48 = 49;
LogoParser.T__49 = 50;
LogoParser.T__50 = 51;
LogoParser.T__51 = 52;
LogoParser.T__52 = 53;
LogoParser.T__53 = 54;
LogoParser.T__54 = 55;
LogoParser.T__55 = 56;
LogoParser.T__56 = 57;
LogoParser.T__57 = 58;
LogoParser.T__58 = 59;
LogoParser.T__59 = 60;
LogoParser.T__60 = 61;
LogoParser.T__61 = 62;
LogoParser.T__62 = 63;
LogoParser.T__63 = 64;
LogoParser.T__64 = 65;
LogoParser.T__65 = 66;
LogoParser.T__66 = 67;
LogoParser.T__67 = 68;
LogoParser.T__68 = 69;
LogoParser.T__69 = 70;
LogoParser.T__70 = 71;
LogoParser.T__71 = 72;
LogoParser.T__72 = 73;
LogoParser.T__73 = 74;
LogoParser.T__74 = 75;
LogoParser.T__75 = 76;
LogoParser.T__76 = 77;
LogoParser.T__77 = 78;
LogoParser.T__78 = 79;
LogoParser.T__79 = 80;
LogoParser.T__80 = 81;
LogoParser.T__81 = 82;
LogoParser.T__82 = 83;
LogoParser.T__83 = 84;
LogoParser.T__84 = 85;
LogoParser.T__85 = 86;
LogoParser.T__86 = 87;
LogoParser.T__87 = 88;
LogoParser.T__88 = 89;
LogoParser.T__89 = 90;
LogoParser.T__90 = 91;
LogoParser.T__91 = 92;
LogoParser.T__92 = 93;
LogoParser.T__93 = 94;
LogoParser.T__94 = 95;
LogoParser.T__95 = 96;
LogoParser.T__96 = 97;
LogoParser.T__97 = 98;
LogoParser.T__98 = 99;
LogoParser.T__99 = 100;
LogoParser.T__100 = 101;
LogoParser.T__101 = 102;
LogoParser.T__102 = 103;
LogoParser.T__103 = 104;
LogoParser.T__104 = 105;
LogoParser.T__105 = 106;
LogoParser.T__106 = 107;
LogoParser.T__107 = 108;
LogoParser.STRINGLITERAL = 109;
LogoParser.STRING = 110;
LogoParser.LPAREN = 111;
LogoParser.RPAREN = 112;
LogoParser.NUMBER = 113;
LogoParser.COMMENT = 114;
LogoParser.EOL = 115;
LogoParser.WS = 116;

LogoParser.RULE_prog = 0;
LogoParser.RULE_line = 1;
LogoParser.RULE_cmd = 2;
LogoParser.RULE_procedureInvocation = 3;
LogoParser.RULE_procedureDeclaration = 4;
LogoParser.RULE_parameterDeclarations = 5;
LogoParser.RULE_func = 6;
LogoParser.RULE_repeat = 7;
LogoParser.RULE_whilee = 8;
LogoParser.RULE_block = 9;
LogoParser.RULE_ife = 10;
LogoParser.RULE_expression = 11;
LogoParser.RULE_comparisonOperator = 12;
LogoParser.RULE_sExpr = 13;
LogoParser.RULE_term = 14;
LogoParser.RULE_factor = 15;
LogoParser.RULE_nsFact = 16;
LogoParser.RULE_value = 17;
LogoParser.RULE_deref = 18;
LogoParser.RULE_colorname = 19;
LogoParser.RULE_rgb = 20;
LogoParser.RULE_colornumber = 21;
LogoParser.RULE_make = 22;
LogoParser.RULE_print = 23;
LogoParser.RULE_quotedstring = 24;
LogoParser.RULE_name = 25;
LogoParser.RULE_fd = 26;
LogoParser.RULE_bk = 27;
LogoParser.RULE_rt = 28;
LogoParser.RULE_lt = 29;
LogoParser.RULE_cs = 30;
LogoParser.RULE_retry = 31;
LogoParser.RULE_next = 32;
LogoParser.RULE_last = 33;
LogoParser.RULE_ct = 34;
LogoParser.RULE_pu = 35;
LogoParser.RULE_pd = 36;
LogoParser.RULE_pe = 37;
LogoParser.RULE_ppt = 38;
LogoParser.RULE_ht = 39;
LogoParser.RULE_st = 40;
LogoParser.RULE_setpc = 41;
LogoParser.RULE_setsc = 42;
LogoParser.RULE_home = 43;
LogoParser.RULE_stop = 44;
LogoParser.RULE_setxy = 45;
LogoParser.RULE_setx = 46;
LogoParser.RULE_sety = 47;
LogoParser.RULE_random = 48;
LogoParser.RULE_sin = 49;
LogoParser.RULE_cos = 50;
LogoParser.RULE_tan = 51;
LogoParser.RULE_arcsin = 52;
LogoParser.RULE_arccos = 53;
LogoParser.RULE_arctan = 54;
LogoParser.RULE_abs = 55;
LogoParser.RULE_sqrt = 56;
LogoParser.RULE_mod = 57;
LogoParser.RULE_power = 58;
LogoParser.RULE_log10 = 59;
LogoParser.RULE_waite = 60;
LogoParser.RULE_wash = 61;
LogoParser.RULE_setpw = 62;
LogoParser.RULE_circle = 63;
LogoParser.RULE_setheading = 64;
LogoParser.RULE_number = 65;
LogoParser.RULE_comment = 66;
LogoParser.RULE_pie = 67;
LogoParser.RULE_ee = 68;
LogoParser.RULE_unitTest = 69;
LogoParser.RULE_createTestCase = 70;
LogoParser.RULE_generateSolutions = 71;
LogoParser.RULE_unitTestBook = 72;

function ProgContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_prog;
    return this;
}

ProgContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ProgContext.prototype.constructor = ProgContext;

ProgContext.prototype.EOL = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LogoParser.EOL);
    } else {
        return this.getToken(LogoParser.EOL, i);
    }
};


ProgContext.prototype.line = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(LineContext);
    } else {
        return this.getTypedRuleContext(LineContext,i);
    }
};

ProgContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterProg(this);
	}
};

ProgContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitProg(this);
	}
};

ProgContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitProg(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.ProgContext = ProgContext;

LogoParser.prototype.prog = function() {

    var localctx = new ProgContext(this, this._ctx, this.state);
    this.enterRule(localctx, 0, LogoParser.RULE_prog);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 150; 
        this._errHandler.sync(this);
        var _alt = 1;
        do {
        	switch (_alt) {
        	case 1:
        		this.state = 147;
        		_la = this._input.LA(1);
        		if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoParser.T__3) | (1 << LogoParser.T__4) | (1 << LogoParser.T__7))) !== 0) || ((((_la - 39)) & ~0x1f) == 0 && ((1 << (_la - 39)) & ((1 << (LogoParser.T__38 - 39)) | (1 << (LogoParser.T__39 - 39)) | (1 << (LogoParser.T__40 - 39)) | (1 << (LogoParser.T__41 - 39)) | (1 << (LogoParser.T__42 - 39)) | (1 << (LogoParser.T__43 - 39)) | (1 << (LogoParser.T__44 - 39)) | (1 << (LogoParser.T__45 - 39)) | (1 << (LogoParser.T__46 - 39)) | (1 << (LogoParser.T__47 - 39)) | (1 << (LogoParser.T__48 - 39)) | (1 << (LogoParser.T__49 - 39)) | (1 << (LogoParser.T__50 - 39)) | (1 << (LogoParser.T__51 - 39)) | (1 << (LogoParser.T__53 - 39)) | (1 << (LogoParser.T__54 - 39)) | (1 << (LogoParser.T__55 - 39)) | (1 << (LogoParser.T__56 - 39)) | (1 << (LogoParser.T__57 - 39)) | (1 << (LogoParser.T__58 - 39)) | (1 << (LogoParser.T__59 - 39)) | (1 << (LogoParser.T__60 - 39)) | (1 << (LogoParser.T__61 - 39)) | (1 << (LogoParser.T__62 - 39)) | (1 << (LogoParser.T__63 - 39)) | (1 << (LogoParser.T__64 - 39)) | (1 << (LogoParser.T__65 - 39)) | (1 << (LogoParser.T__66 - 39)) | (1 << (LogoParser.T__67 - 39)) | (1 << (LogoParser.T__68 - 39)) | (1 << (LogoParser.T__69 - 39)))) !== 0) || ((((_la - 71)) & ~0x1f) == 0 && ((1 << (_la - 71)) & ((1 << (LogoParser.T__70 - 71)) | (1 << (LogoParser.T__71 - 71)) | (1 << (LogoParser.T__72 - 71)) | (1 << (LogoParser.T__73 - 71)) | (1 << (LogoParser.T__74 - 71)) | (1 << (LogoParser.T__75 - 71)) | (1 << (LogoParser.T__76 - 71)) | (1 << (LogoParser.T__95 - 71)) | (1 << (LogoParser.T__96 - 71)) | (1 << (LogoParser.T__97 - 71)) | (1 << (LogoParser.T__98 - 71)) | (1 << (LogoParser.T__99 - 71)) | (1 << (LogoParser.T__100 - 71)))) !== 0) || ((((_la - 105)) & ~0x1f) == 0 && ((1 << (_la - 105)) & ((1 << (LogoParser.T__104 - 105)) | (1 << (LogoParser.T__105 - 105)) | (1 << (LogoParser.T__106 - 105)) | (1 << (LogoParser.T__107 - 105)) | (1 << (LogoParser.STRING - 105)) | (1 << (LogoParser.COMMENT - 105)))) !== 0)) {
        		    this.state = 146;
        		    this.line();
        		}

        		this.state = 149;
        		this.match(LogoParser.EOL);
        		break;
        	default:
        		throw new antlr4.error.NoViableAltException(this);
        	}
        	this.state = 152; 
        	this._errHandler.sync(this);
        	_alt = this._interp.adaptivePredict(this._input,1, this._ctx);
        } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
        this.state = 155;
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoParser.T__3) | (1 << LogoParser.T__4) | (1 << LogoParser.T__7))) !== 0) || ((((_la - 39)) & ~0x1f) == 0 && ((1 << (_la - 39)) & ((1 << (LogoParser.T__38 - 39)) | (1 << (LogoParser.T__39 - 39)) | (1 << (LogoParser.T__40 - 39)) | (1 << (LogoParser.T__41 - 39)) | (1 << (LogoParser.T__42 - 39)) | (1 << (LogoParser.T__43 - 39)) | (1 << (LogoParser.T__44 - 39)) | (1 << (LogoParser.T__45 - 39)) | (1 << (LogoParser.T__46 - 39)) | (1 << (LogoParser.T__47 - 39)) | (1 << (LogoParser.T__48 - 39)) | (1 << (LogoParser.T__49 - 39)) | (1 << (LogoParser.T__50 - 39)) | (1 << (LogoParser.T__51 - 39)) | (1 << (LogoParser.T__53 - 39)) | (1 << (LogoParser.T__54 - 39)) | (1 << (LogoParser.T__55 - 39)) | (1 << (LogoParser.T__56 - 39)) | (1 << (LogoParser.T__57 - 39)) | (1 << (LogoParser.T__58 - 39)) | (1 << (LogoParser.T__59 - 39)) | (1 << (LogoParser.T__60 - 39)) | (1 << (LogoParser.T__61 - 39)) | (1 << (LogoParser.T__62 - 39)) | (1 << (LogoParser.T__63 - 39)) | (1 << (LogoParser.T__64 - 39)) | (1 << (LogoParser.T__65 - 39)) | (1 << (LogoParser.T__66 - 39)) | (1 << (LogoParser.T__67 - 39)) | (1 << (LogoParser.T__68 - 39)) | (1 << (LogoParser.T__69 - 39)))) !== 0) || ((((_la - 71)) & ~0x1f) == 0 && ((1 << (_la - 71)) & ((1 << (LogoParser.T__70 - 71)) | (1 << (LogoParser.T__71 - 71)) | (1 << (LogoParser.T__72 - 71)) | (1 << (LogoParser.T__73 - 71)) | (1 << (LogoParser.T__74 - 71)) | (1 << (LogoParser.T__75 - 71)) | (1 << (LogoParser.T__76 - 71)) | (1 << (LogoParser.T__95 - 71)) | (1 << (LogoParser.T__96 - 71)) | (1 << (LogoParser.T__97 - 71)) | (1 << (LogoParser.T__98 - 71)) | (1 << (LogoParser.T__99 - 71)) | (1 << (LogoParser.T__100 - 71)))) !== 0) || ((((_la - 105)) & ~0x1f) == 0 && ((1 << (_la - 105)) & ((1 << (LogoParser.T__104 - 105)) | (1 << (LogoParser.T__105 - 105)) | (1 << (LogoParser.T__106 - 105)) | (1 << (LogoParser.T__107 - 105)) | (1 << (LogoParser.STRING - 105)) | (1 << (LogoParser.COMMENT - 105)))) !== 0)) {
            this.state = 154;
            this.line();
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function LineContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_line;
    return this;
}

LineContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LineContext.prototype.constructor = LineContext;

LineContext.prototype.cmd = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(CmdContext);
    } else {
        return this.getTypedRuleContext(CmdContext,i);
    }
};

LineContext.prototype.comment = function() {
    return this.getTypedRuleContext(CommentContext,0);
};

LineContext.prototype.print = function() {
    return this.getTypedRuleContext(PrintContext,0);
};

LineContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterLine(this);
	}
};

LineContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitLine(this);
	}
};

LineContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitLine(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.LineContext = LineContext;

LogoParser.prototype.line = function() {

    var localctx = new LineContext(this, this._ctx, this.state);
    this.enterRule(localctx, 2, LogoParser.RULE_line);
    var _la = 0; // Token type
    try {
        this.state = 170;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,6,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 158; 
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            do {
                this.state = 157;
                this.cmd();
                this.state = 160; 
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            } while((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoParser.T__3) | (1 << LogoParser.T__4) | (1 << LogoParser.T__7))) !== 0) || ((((_la - 39)) & ~0x1f) == 0 && ((1 << (_la - 39)) & ((1 << (LogoParser.T__38 - 39)) | (1 << (LogoParser.T__39 - 39)) | (1 << (LogoParser.T__40 - 39)) | (1 << (LogoParser.T__41 - 39)) | (1 << (LogoParser.T__42 - 39)) | (1 << (LogoParser.T__43 - 39)) | (1 << (LogoParser.T__44 - 39)) | (1 << (LogoParser.T__45 - 39)) | (1 << (LogoParser.T__46 - 39)) | (1 << (LogoParser.T__47 - 39)) | (1 << (LogoParser.T__48 - 39)) | (1 << (LogoParser.T__49 - 39)) | (1 << (LogoParser.T__50 - 39)) | (1 << (LogoParser.T__51 - 39)) | (1 << (LogoParser.T__53 - 39)) | (1 << (LogoParser.T__54 - 39)) | (1 << (LogoParser.T__55 - 39)) | (1 << (LogoParser.T__56 - 39)) | (1 << (LogoParser.T__57 - 39)) | (1 << (LogoParser.T__58 - 39)) | (1 << (LogoParser.T__59 - 39)) | (1 << (LogoParser.T__60 - 39)) | (1 << (LogoParser.T__61 - 39)) | (1 << (LogoParser.T__62 - 39)) | (1 << (LogoParser.T__63 - 39)) | (1 << (LogoParser.T__64 - 39)) | (1 << (LogoParser.T__65 - 39)) | (1 << (LogoParser.T__66 - 39)) | (1 << (LogoParser.T__67 - 39)) | (1 << (LogoParser.T__68 - 39)) | (1 << (LogoParser.T__69 - 39)))) !== 0) || ((((_la - 71)) & ~0x1f) == 0 && ((1 << (_la - 71)) & ((1 << (LogoParser.T__70 - 71)) | (1 << (LogoParser.T__71 - 71)) | (1 << (LogoParser.T__72 - 71)) | (1 << (LogoParser.T__73 - 71)) | (1 << (LogoParser.T__74 - 71)) | (1 << (LogoParser.T__75 - 71)) | (1 << (LogoParser.T__76 - 71)) | (1 << (LogoParser.T__95 - 71)) | (1 << (LogoParser.T__96 - 71)) | (1 << (LogoParser.T__97 - 71)) | (1 << (LogoParser.T__98 - 71)) | (1 << (LogoParser.T__99 - 71)) | (1 << (LogoParser.T__100 - 71)))) !== 0) || ((((_la - 105)) & ~0x1f) == 0 && ((1 << (_la - 105)) & ((1 << (LogoParser.T__104 - 105)) | (1 << (LogoParser.T__105 - 105)) | (1 << (LogoParser.T__106 - 105)) | (1 << (LogoParser.T__107 - 105)) | (1 << (LogoParser.STRING - 105)))) !== 0));
            this.state = 163;
            _la = this._input.LA(1);
            if(_la===LogoParser.COMMENT) {
                this.state = 162;
                this.comment();
            }

            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 165;
            this.comment();
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 166;
            this.print();
            this.state = 168;
            _la = this._input.LA(1);
            if(_la===LogoParser.COMMENT) {
                this.state = 167;
                this.comment();
            }

            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function CmdContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_cmd;
    return this;
}

CmdContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
CmdContext.prototype.constructor = CmdContext;

CmdContext.prototype.repeat = function() {
    return this.getTypedRuleContext(RepeatContext,0);
};

CmdContext.prototype.fd = function() {
    return this.getTypedRuleContext(FdContext,0);
};

CmdContext.prototype.bk = function() {
    return this.getTypedRuleContext(BkContext,0);
};

CmdContext.prototype.rt = function() {
    return this.getTypedRuleContext(RtContext,0);
};

CmdContext.prototype.lt = function() {
    return this.getTypedRuleContext(LtContext,0);
};

CmdContext.prototype.cs = function() {
    return this.getTypedRuleContext(CsContext,0);
};

CmdContext.prototype.next = function() {
    return this.getTypedRuleContext(NextContext,0);
};

CmdContext.prototype.last = function() {
    return this.getTypedRuleContext(LastContext,0);
};

CmdContext.prototype.ct = function() {
    return this.getTypedRuleContext(CtContext,0);
};

CmdContext.prototype.pu = function() {
    return this.getTypedRuleContext(PuContext,0);
};

CmdContext.prototype.pd = function() {
    return this.getTypedRuleContext(PdContext,0);
};

CmdContext.prototype.ht = function() {
    return this.getTypedRuleContext(HtContext,0);
};

CmdContext.prototype.st = function() {
    return this.getTypedRuleContext(StContext,0);
};

CmdContext.prototype.pe = function() {
    return this.getTypedRuleContext(PeContext,0);
};

CmdContext.prototype.ppt = function() {
    return this.getTypedRuleContext(PptContext,0);
};

CmdContext.prototype.home = function() {
    return this.getTypedRuleContext(HomeContext,0);
};

CmdContext.prototype.setx = function() {
    return this.getTypedRuleContext(SetxContext,0);
};

CmdContext.prototype.sety = function() {
    return this.getTypedRuleContext(SetyContext,0);
};

CmdContext.prototype.setxy = function() {
    return this.getTypedRuleContext(SetxyContext,0);
};

CmdContext.prototype.setpc = function() {
    return this.getTypedRuleContext(SetpcContext,0);
};

CmdContext.prototype.setsc = function() {
    return this.getTypedRuleContext(SetscContext,0);
};

CmdContext.prototype.make = function() {
    return this.getTypedRuleContext(MakeContext,0);
};

CmdContext.prototype.procedureInvocation = function() {
    return this.getTypedRuleContext(ProcedureInvocationContext,0);
};

CmdContext.prototype.ife = function() {
    return this.getTypedRuleContext(IfeContext,0);
};

CmdContext.prototype.stop = function() {
    return this.getTypedRuleContext(StopContext,0);
};

CmdContext.prototype.waite = function() {
    return this.getTypedRuleContext(WaiteContext,0);
};

CmdContext.prototype.whilee = function() {
    return this.getTypedRuleContext(WhileeContext,0);
};

CmdContext.prototype.wash = function() {
    return this.getTypedRuleContext(WashContext,0);
};

CmdContext.prototype.setpw = function() {
    return this.getTypedRuleContext(SetpwContext,0);
};

CmdContext.prototype.circle = function() {
    return this.getTypedRuleContext(CircleContext,0);
};

CmdContext.prototype.setheading = function() {
    return this.getTypedRuleContext(SetheadingContext,0);
};

CmdContext.prototype.print = function() {
    return this.getTypedRuleContext(PrintContext,0);
};

CmdContext.prototype.unitTest = function() {
    return this.getTypedRuleContext(UnitTestContext,0);
};

CmdContext.prototype.unitTestBook = function() {
    return this.getTypedRuleContext(UnitTestBookContext,0);
};

CmdContext.prototype.createTestCase = function() {
    return this.getTypedRuleContext(CreateTestCaseContext,0);
};

CmdContext.prototype.generateSolutions = function() {
    return this.getTypedRuleContext(GenerateSolutionsContext,0);
};

CmdContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterCmd(this);
	}
};

CmdContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitCmd(this);
	}
};

CmdContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitCmd(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.CmdContext = CmdContext;

LogoParser.prototype.cmd = function() {

    var localctx = new CmdContext(this, this._ctx, this.state);
    this.enterRule(localctx, 4, LogoParser.RULE_cmd);
    try {
        this.state = 208;
        switch(this._input.LA(1)) {
        case LogoParser.T__3:
            this.enterOuterAlt(localctx, 1);
            this.state = 172;
            this.repeat();
            break;
        case LogoParser.T__41:
        case LogoParser.T__42:
            this.enterOuterAlt(localctx, 2);
            this.state = 173;
            this.fd();
            break;
        case LogoParser.T__43:
        case LogoParser.T__44:
        case LogoParser.T__45:
            this.enterOuterAlt(localctx, 3);
            this.state = 174;
            this.bk();
            break;
        case LogoParser.T__46:
        case LogoParser.T__47:
            this.enterOuterAlt(localctx, 4);
            this.state = 175;
            this.rt();
            break;
        case LogoParser.T__48:
        case LogoParser.T__49:
            this.enterOuterAlt(localctx, 5);
            this.state = 176;
            this.lt();
            break;
        case LogoParser.T__50:
        case LogoParser.T__51:
            this.enterOuterAlt(localctx, 6);
            this.state = 177;
            this.cs();
            break;
        case LogoParser.T__53:
            this.enterOuterAlt(localctx, 7);
            this.state = 178;
            this.next();
            break;
        case LogoParser.T__54:
            this.enterOuterAlt(localctx, 8);
            this.state = 179;
            this.last();
            break;
        case LogoParser.T__55:
            this.enterOuterAlt(localctx, 9);
            this.state = 180;
            this.ct();
            break;
        case LogoParser.T__56:
        case LogoParser.T__57:
            this.enterOuterAlt(localctx, 10);
            this.state = 181;
            this.pu();
            break;
        case LogoParser.T__58:
        case LogoParser.T__59:
            this.enterOuterAlt(localctx, 11);
            this.state = 182;
            this.pd();
            break;
        case LogoParser.T__64:
        case LogoParser.T__65:
            this.enterOuterAlt(localctx, 12);
            this.state = 183;
            this.ht();
            break;
        case LogoParser.T__66:
        case LogoParser.T__67:
            this.enterOuterAlt(localctx, 13);
            this.state = 184;
            this.st();
            break;
        case LogoParser.T__60:
        case LogoParser.T__61:
            this.enterOuterAlt(localctx, 14);
            this.state = 185;
            this.pe();
            break;
        case LogoParser.T__62:
        case LogoParser.T__63:
            this.enterOuterAlt(localctx, 15);
            this.state = 186;
            this.ppt();
            break;
        case LogoParser.T__72:
            this.enterOuterAlt(localctx, 16);
            this.state = 187;
            this.home();
            break;
        case LogoParser.T__75:
            this.enterOuterAlt(localctx, 17);
            this.state = 188;
            this.setx();
            break;
        case LogoParser.T__76:
            this.enterOuterAlt(localctx, 18);
            this.state = 189;
            this.sety();
            break;
        case LogoParser.T__74:
            this.enterOuterAlt(localctx, 19);
            this.state = 190;
            this.setxy();
            break;
        case LogoParser.T__68:
        case LogoParser.T__69:
            this.enterOuterAlt(localctx, 20);
            this.state = 191;
            this.setpc();
            break;
        case LogoParser.T__70:
        case LogoParser.T__71:
            this.enterOuterAlt(localctx, 21);
            this.state = 192;
            this.setsc();
            break;
        case LogoParser.T__38:
            this.enterOuterAlt(localctx, 22);
            this.state = 193;
            this.make();
            break;
        case LogoParser.STRING:
            this.enterOuterAlt(localctx, 23);
            this.state = 194;
            this.procedureInvocation();
            break;
        case LogoParser.T__7:
            this.enterOuterAlt(localctx, 24);
            this.state = 195;
            this.ife();
            break;
        case LogoParser.T__73:
            this.enterOuterAlt(localctx, 25);
            this.state = 196;
            this.stop();
            break;
        case LogoParser.T__95:
            this.enterOuterAlt(localctx, 26);
            this.state = 197;
            this.waite();
            break;
        case LogoParser.T__4:
            this.enterOuterAlt(localctx, 27);
            this.state = 198;
            this.whilee();
            break;
        case LogoParser.T__96:
            this.enterOuterAlt(localctx, 28);
            this.state = 199;
            this.wash();
            break;
        case LogoParser.T__97:
        case LogoParser.T__98:
            this.enterOuterAlt(localctx, 29);
            this.state = 200;
            this.setpw();
            break;
        case LogoParser.T__99:
            this.enterOuterAlt(localctx, 30);
            this.state = 201;
            this.circle();
            break;
        case LogoParser.T__100:
            this.enterOuterAlt(localctx, 31);
            this.state = 202;
            this.setheading();
            break;
        case LogoParser.T__39:
        case LogoParser.T__40:
            this.enterOuterAlt(localctx, 32);
            this.state = 203;
            this.print();
            break;
        case LogoParser.T__104:
            this.enterOuterAlt(localctx, 33);
            this.state = 204;
            this.unitTest();
            break;
        case LogoParser.T__107:
            this.enterOuterAlt(localctx, 34);
            this.state = 205;
            this.unitTestBook();
            break;
        case LogoParser.T__105:
            this.enterOuterAlt(localctx, 35);
            this.state = 206;
            this.createTestCase();
            break;
        case LogoParser.T__106:
            this.enterOuterAlt(localctx, 36);
            this.state = 207;
            this.generateSolutions();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ProcedureInvocationContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_procedureInvocation;
    return this;
}

ProcedureInvocationContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ProcedureInvocationContext.prototype.constructor = ProcedureInvocationContext;

ProcedureInvocationContext.prototype.name = function() {
    return this.getTypedRuleContext(NameContext,0);
};

ProcedureInvocationContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

ProcedureInvocationContext.prototype.rgb = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(RgbContext);
    } else {
        return this.getTypedRuleContext(RgbContext,i);
    }
};

ProcedureInvocationContext.prototype.colorname = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ColornameContext);
    } else {
        return this.getTypedRuleContext(ColornameContext,i);
    }
};

ProcedureInvocationContext.prototype.quotedstring = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(QuotedstringContext);
    } else {
        return this.getTypedRuleContext(QuotedstringContext,i);
    }
};

ProcedureInvocationContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterProcedureInvocation(this);
	}
};

ProcedureInvocationContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitProcedureInvocation(this);
	}
};

ProcedureInvocationContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitProcedureInvocation(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.ProcedureInvocationContext = ProcedureInvocationContext;

LogoParser.prototype.procedureInvocation = function() {

    var localctx = new ProcedureInvocationContext(this, this._ctx, this.state);
    this.enterRule(localctx, 6, LogoParser.RULE_procedureInvocation);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 210;
        this.name();
        this.state = 217;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoParser.T__2) | (1 << LogoParser.T__5) | (1 << LogoParser.T__14) | (1 << LogoParser.T__15) | (1 << LogoParser.T__20) | (1 << LogoParser.T__21) | (1 << LogoParser.T__22) | (1 << LogoParser.T__23) | (1 << LogoParser.T__24) | (1 << LogoParser.T__25) | (1 << LogoParser.T__26) | (1 << LogoParser.T__27) | (1 << LogoParser.T__28) | (1 << LogoParser.T__29) | (1 << LogoParser.T__30))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (LogoParser.T__31 - 32)) | (1 << (LogoParser.T__32 - 32)) | (1 << (LogoParser.T__33 - 32)) | (1 << (LogoParser.T__34 - 32)) | (1 << (LogoParser.T__35 - 32)) | (1 << (LogoParser.T__36 - 32)) | (1 << (LogoParser.T__37 - 32)))) !== 0) || ((((_la - 78)) & ~0x1f) == 0 && ((1 << (_la - 78)) & ((1 << (LogoParser.T__77 - 78)) | (1 << (LogoParser.T__78 - 78)) | (1 << (LogoParser.T__79 - 78)) | (1 << (LogoParser.T__80 - 78)) | (1 << (LogoParser.T__81 - 78)) | (1 << (LogoParser.T__82 - 78)) | (1 << (LogoParser.T__83 - 78)) | (1 << (LogoParser.T__84 - 78)) | (1 << (LogoParser.T__85 - 78)) | (1 << (LogoParser.T__86 - 78)) | (1 << (LogoParser.T__87 - 78)) | (1 << (LogoParser.T__88 - 78)) | (1 << (LogoParser.T__89 - 78)) | (1 << (LogoParser.T__90 - 78)) | (1 << (LogoParser.T__91 - 78)) | (1 << (LogoParser.T__92 - 78)) | (1 << (LogoParser.T__93 - 78)) | (1 << (LogoParser.T__94 - 78)) | (1 << (LogoParser.T__102 - 78)) | (1 << (LogoParser.T__103 - 78)))) !== 0) || _la===LogoParser.LPAREN || _la===LogoParser.NUMBER) {
            this.state = 215;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,8,this._ctx);
            switch(la_) {
            case 1:
                this.state = 211;
                this.expression();
                break;

            case 2:
                this.state = 212;
                this.rgb();
                break;

            case 3:
                this.state = 213;
                this.colorname();
                break;

            case 4:
                this.state = 214;
                this.quotedstring();
                break;

            }
            this.state = 219;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ProcedureDeclarationContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_procedureDeclaration;
    return this;
}

ProcedureDeclarationContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ProcedureDeclarationContext.prototype.constructor = ProcedureDeclarationContext;

ProcedureDeclarationContext.prototype.name = function() {
    return this.getTypedRuleContext(NameContext,0);
};

ProcedureDeclarationContext.prototype.EOL = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LogoParser.EOL);
    } else {
        return this.getToken(LogoParser.EOL, i);
    }
};


ProcedureDeclarationContext.prototype.parameterDeclarations = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ParameterDeclarationsContext);
    } else {
        return this.getTypedRuleContext(ParameterDeclarationsContext,i);
    }
};

ProcedureDeclarationContext.prototype.line = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(LineContext);
    } else {
        return this.getTypedRuleContext(LineContext,i);
    }
};

ProcedureDeclarationContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterProcedureDeclaration(this);
	}
};

ProcedureDeclarationContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitProcedureDeclaration(this);
	}
};

ProcedureDeclarationContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitProcedureDeclaration(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.ProcedureDeclarationContext = ProcedureDeclarationContext;

LogoParser.prototype.procedureDeclaration = function() {

    var localctx = new ProcedureDeclarationContext(this, this._ctx, this.state);
    this.enterRule(localctx, 8, LogoParser.RULE_procedureDeclaration);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 220;
        this.match(LogoParser.T__0);
        this.state = 221;
        this.name();
        this.state = 225;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(_la===LogoParser.T__2) {
            this.state = 222;
            this.parameterDeclarations();
            this.state = 227;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
        this.state = 228;
        this.match(LogoParser.EOL);
        this.state = 235;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoParser.T__3) | (1 << LogoParser.T__4) | (1 << LogoParser.T__7))) !== 0) || ((((_la - 39)) & ~0x1f) == 0 && ((1 << (_la - 39)) & ((1 << (LogoParser.T__38 - 39)) | (1 << (LogoParser.T__39 - 39)) | (1 << (LogoParser.T__40 - 39)) | (1 << (LogoParser.T__41 - 39)) | (1 << (LogoParser.T__42 - 39)) | (1 << (LogoParser.T__43 - 39)) | (1 << (LogoParser.T__44 - 39)) | (1 << (LogoParser.T__45 - 39)) | (1 << (LogoParser.T__46 - 39)) | (1 << (LogoParser.T__47 - 39)) | (1 << (LogoParser.T__48 - 39)) | (1 << (LogoParser.T__49 - 39)) | (1 << (LogoParser.T__50 - 39)) | (1 << (LogoParser.T__51 - 39)) | (1 << (LogoParser.T__53 - 39)) | (1 << (LogoParser.T__54 - 39)) | (1 << (LogoParser.T__55 - 39)) | (1 << (LogoParser.T__56 - 39)) | (1 << (LogoParser.T__57 - 39)) | (1 << (LogoParser.T__58 - 39)) | (1 << (LogoParser.T__59 - 39)) | (1 << (LogoParser.T__60 - 39)) | (1 << (LogoParser.T__61 - 39)) | (1 << (LogoParser.T__62 - 39)) | (1 << (LogoParser.T__63 - 39)) | (1 << (LogoParser.T__64 - 39)) | (1 << (LogoParser.T__65 - 39)) | (1 << (LogoParser.T__66 - 39)) | (1 << (LogoParser.T__67 - 39)) | (1 << (LogoParser.T__68 - 39)) | (1 << (LogoParser.T__69 - 39)))) !== 0) || ((((_la - 71)) & ~0x1f) == 0 && ((1 << (_la - 71)) & ((1 << (LogoParser.T__70 - 71)) | (1 << (LogoParser.T__71 - 71)) | (1 << (LogoParser.T__72 - 71)) | (1 << (LogoParser.T__73 - 71)) | (1 << (LogoParser.T__74 - 71)) | (1 << (LogoParser.T__75 - 71)) | (1 << (LogoParser.T__76 - 71)) | (1 << (LogoParser.T__95 - 71)) | (1 << (LogoParser.T__96 - 71)) | (1 << (LogoParser.T__97 - 71)) | (1 << (LogoParser.T__98 - 71)) | (1 << (LogoParser.T__99 - 71)) | (1 << (LogoParser.T__100 - 71)))) !== 0) || ((((_la - 105)) & ~0x1f) == 0 && ((1 << (_la - 105)) & ((1 << (LogoParser.T__104 - 105)) | (1 << (LogoParser.T__105 - 105)) | (1 << (LogoParser.T__106 - 105)) | (1 << (LogoParser.T__107 - 105)) | (1 << (LogoParser.STRING - 105)) | (1 << (LogoParser.COMMENT - 105)) | (1 << (LogoParser.EOL - 105)))) !== 0)) {
            this.state = 230;
            _la = this._input.LA(1);
            if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoParser.T__3) | (1 << LogoParser.T__4) | (1 << LogoParser.T__7))) !== 0) || ((((_la - 39)) & ~0x1f) == 0 && ((1 << (_la - 39)) & ((1 << (LogoParser.T__38 - 39)) | (1 << (LogoParser.T__39 - 39)) | (1 << (LogoParser.T__40 - 39)) | (1 << (LogoParser.T__41 - 39)) | (1 << (LogoParser.T__42 - 39)) | (1 << (LogoParser.T__43 - 39)) | (1 << (LogoParser.T__44 - 39)) | (1 << (LogoParser.T__45 - 39)) | (1 << (LogoParser.T__46 - 39)) | (1 << (LogoParser.T__47 - 39)) | (1 << (LogoParser.T__48 - 39)) | (1 << (LogoParser.T__49 - 39)) | (1 << (LogoParser.T__50 - 39)) | (1 << (LogoParser.T__51 - 39)) | (1 << (LogoParser.T__53 - 39)) | (1 << (LogoParser.T__54 - 39)) | (1 << (LogoParser.T__55 - 39)) | (1 << (LogoParser.T__56 - 39)) | (1 << (LogoParser.T__57 - 39)) | (1 << (LogoParser.T__58 - 39)) | (1 << (LogoParser.T__59 - 39)) | (1 << (LogoParser.T__60 - 39)) | (1 << (LogoParser.T__61 - 39)) | (1 << (LogoParser.T__62 - 39)) | (1 << (LogoParser.T__63 - 39)) | (1 << (LogoParser.T__64 - 39)) | (1 << (LogoParser.T__65 - 39)) | (1 << (LogoParser.T__66 - 39)) | (1 << (LogoParser.T__67 - 39)) | (1 << (LogoParser.T__68 - 39)) | (1 << (LogoParser.T__69 - 39)))) !== 0) || ((((_la - 71)) & ~0x1f) == 0 && ((1 << (_la - 71)) & ((1 << (LogoParser.T__70 - 71)) | (1 << (LogoParser.T__71 - 71)) | (1 << (LogoParser.T__72 - 71)) | (1 << (LogoParser.T__73 - 71)) | (1 << (LogoParser.T__74 - 71)) | (1 << (LogoParser.T__75 - 71)) | (1 << (LogoParser.T__76 - 71)) | (1 << (LogoParser.T__95 - 71)) | (1 << (LogoParser.T__96 - 71)) | (1 << (LogoParser.T__97 - 71)) | (1 << (LogoParser.T__98 - 71)) | (1 << (LogoParser.T__99 - 71)) | (1 << (LogoParser.T__100 - 71)))) !== 0) || ((((_la - 105)) & ~0x1f) == 0 && ((1 << (_la - 105)) & ((1 << (LogoParser.T__104 - 105)) | (1 << (LogoParser.T__105 - 105)) | (1 << (LogoParser.T__106 - 105)) | (1 << (LogoParser.T__107 - 105)) | (1 << (LogoParser.STRING - 105)) | (1 << (LogoParser.COMMENT - 105)))) !== 0)) {
                this.state = 229;
                this.line();
            }

            this.state = 232;
            this.match(LogoParser.EOL);
            this.state = 237;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
        this.state = 238;
        this.match(LogoParser.T__1);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ParameterDeclarationsContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_parameterDeclarations;
    return this;
}

ParameterDeclarationsContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ParameterDeclarationsContext.prototype.constructor = ParameterDeclarationsContext;

ParameterDeclarationsContext.prototype.name = function() {
    return this.getTypedRuleContext(NameContext,0);
};

ParameterDeclarationsContext.prototype.parameterDeclarations = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ParameterDeclarationsContext);
    } else {
        return this.getTypedRuleContext(ParameterDeclarationsContext,i);
    }
};

ParameterDeclarationsContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterParameterDeclarations(this);
	}
};

ParameterDeclarationsContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitParameterDeclarations(this);
	}
};

ParameterDeclarationsContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitParameterDeclarations(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.ParameterDeclarationsContext = ParameterDeclarationsContext;

LogoParser.prototype.parameterDeclarations = function() {

    var localctx = new ParameterDeclarationsContext(this, this._ctx, this.state);
    this.enterRule(localctx, 10, LogoParser.RULE_parameterDeclarations);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 240;
        this.match(LogoParser.T__2);
        this.state = 241;
        this.name();
        this.state = 245;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input,13,this._ctx)
        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
            if(_alt===1) {
                this.state = 242;
                this.parameterDeclarations(); 
            }
            this.state = 247;
            this._errHandler.sync(this);
            _alt = this._interp.adaptivePredict(this._input,13,this._ctx);
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function FuncContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_func;
    return this;
}

FuncContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
FuncContext.prototype.constructor = FuncContext;

FuncContext.prototype.random = function() {
    return this.getTypedRuleContext(RandomContext,0);
};

FuncContext.prototype.sin = function() {
    return this.getTypedRuleContext(SinContext,0);
};

FuncContext.prototype.cos = function() {
    return this.getTypedRuleContext(CosContext,0);
};

FuncContext.prototype.tan = function() {
    return this.getTypedRuleContext(TanContext,0);
};

FuncContext.prototype.arcsin = function() {
    return this.getTypedRuleContext(ArcsinContext,0);
};

FuncContext.prototype.arccos = function() {
    return this.getTypedRuleContext(ArccosContext,0);
};

FuncContext.prototype.arctan = function() {
    return this.getTypedRuleContext(ArctanContext,0);
};

FuncContext.prototype.abs = function() {
    return this.getTypedRuleContext(AbsContext,0);
};

FuncContext.prototype.sqrt = function() {
    return this.getTypedRuleContext(SqrtContext,0);
};

FuncContext.prototype.mod = function() {
    return this.getTypedRuleContext(ModContext,0);
};

FuncContext.prototype.power = function() {
    return this.getTypedRuleContext(PowerContext,0);
};

FuncContext.prototype.log10 = function() {
    return this.getTypedRuleContext(Log10Context,0);
};

FuncContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterFunc(this);
	}
};

FuncContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitFunc(this);
	}
};

FuncContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitFunc(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.FuncContext = FuncContext;

LogoParser.prototype.func = function() {

    var localctx = new FuncContext(this, this._ctx, this.state);
    this.enterRule(localctx, 12, LogoParser.RULE_func);
    try {
        this.state = 260;
        switch(this._input.LA(1)) {
        case LogoParser.T__77:
        case LogoParser.T__78:
        case LogoParser.T__79:
            this.enterOuterAlt(localctx, 1);
            this.state = 248;
            this.random();
            break;
        case LogoParser.T__80:
            this.enterOuterAlt(localctx, 2);
            this.state = 249;
            this.sin();
            break;
        case LogoParser.T__81:
            this.enterOuterAlt(localctx, 3);
            this.state = 250;
            this.cos();
            break;
        case LogoParser.T__82:
            this.enterOuterAlt(localctx, 4);
            this.state = 251;
            this.tan();
            break;
        case LogoParser.T__83:
        case LogoParser.T__84:
            this.enterOuterAlt(localctx, 5);
            this.state = 252;
            this.arcsin();
            break;
        case LogoParser.T__85:
        case LogoParser.T__86:
            this.enterOuterAlt(localctx, 6);
            this.state = 253;
            this.arccos();
            break;
        case LogoParser.T__87:
        case LogoParser.T__88:
            this.enterOuterAlt(localctx, 7);
            this.state = 254;
            this.arctan();
            break;
        case LogoParser.T__89:
            this.enterOuterAlt(localctx, 8);
            this.state = 255;
            this.abs();
            break;
        case LogoParser.T__90:
            this.enterOuterAlt(localctx, 9);
            this.state = 256;
            this.sqrt();
            break;
        case LogoParser.T__91:
            this.enterOuterAlt(localctx, 10);
            this.state = 257;
            this.mod();
            break;
        case LogoParser.T__92:
            this.enterOuterAlt(localctx, 11);
            this.state = 258;
            this.power();
            break;
        case LogoParser.T__93:
        case LogoParser.T__94:
            this.enterOuterAlt(localctx, 12);
            this.state = 259;
            this.log10();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function RepeatContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_repeat;
    return this;
}

RepeatContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
RepeatContext.prototype.constructor = RepeatContext;

RepeatContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

RepeatContext.prototype.block = function() {
    return this.getTypedRuleContext(BlockContext,0);
};

RepeatContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterRepeat(this);
	}
};

RepeatContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitRepeat(this);
	}
};

RepeatContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitRepeat(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.RepeatContext = RepeatContext;

LogoParser.prototype.repeat = function() {

    var localctx = new RepeatContext(this, this._ctx, this.state);
    this.enterRule(localctx, 14, LogoParser.RULE_repeat);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 262;
        this.match(LogoParser.T__3);
        this.state = 263;
        this.expression();
        this.state = 264;
        this.block();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function WhileeContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_whilee;
    return this;
}

WhileeContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
WhileeContext.prototype.constructor = WhileeContext;

WhileeContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

WhileeContext.prototype.block = function() {
    return this.getTypedRuleContext(BlockContext,0);
};

WhileeContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterWhilee(this);
	}
};

WhileeContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitWhilee(this);
	}
};

WhileeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitWhilee(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.WhileeContext = WhileeContext;

LogoParser.prototype.whilee = function() {

    var localctx = new WhileeContext(this, this._ctx, this.state);
    this.enterRule(localctx, 16, LogoParser.RULE_whilee);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 266;
        this.match(LogoParser.T__4);
        this.state = 267;
        this.match(LogoParser.T__5);
        this.state = 268;
        this.expression();
        this.state = 269;
        this.match(LogoParser.T__6);
        this.state = 270;
        this.block();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function BlockContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_block;
    return this;
}

BlockContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
BlockContext.prototype.constructor = BlockContext;

BlockContext.prototype.EOL = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LogoParser.EOL);
    } else {
        return this.getToken(LogoParser.EOL, i);
    }
};


BlockContext.prototype.cmd = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(CmdContext);
    } else {
        return this.getTypedRuleContext(CmdContext,i);
    }
};

BlockContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterBlock(this);
	}
};

BlockContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitBlock(this);
	}
};

BlockContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitBlock(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.BlockContext = BlockContext;

LogoParser.prototype.block = function() {

    var localctx = new BlockContext(this, this._ctx, this.state);
    this.enterRule(localctx, 18, LogoParser.RULE_block);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 272;
        this.match(LogoParser.T__5);
        this.state = 276;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input,15,this._ctx)
        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
            if(_alt===1) {
                this.state = 273;
                this.match(LogoParser.EOL); 
            }
            this.state = 278;
            this._errHandler.sync(this);
            _alt = this._interp.adaptivePredict(this._input,15,this._ctx);
        }

        this.state = 282;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoParser.T__3) | (1 << LogoParser.T__4) | (1 << LogoParser.T__7))) !== 0) || ((((_la - 39)) & ~0x1f) == 0 && ((1 << (_la - 39)) & ((1 << (LogoParser.T__38 - 39)) | (1 << (LogoParser.T__39 - 39)) | (1 << (LogoParser.T__40 - 39)) | (1 << (LogoParser.T__41 - 39)) | (1 << (LogoParser.T__42 - 39)) | (1 << (LogoParser.T__43 - 39)) | (1 << (LogoParser.T__44 - 39)) | (1 << (LogoParser.T__45 - 39)) | (1 << (LogoParser.T__46 - 39)) | (1 << (LogoParser.T__47 - 39)) | (1 << (LogoParser.T__48 - 39)) | (1 << (LogoParser.T__49 - 39)) | (1 << (LogoParser.T__50 - 39)) | (1 << (LogoParser.T__51 - 39)) | (1 << (LogoParser.T__53 - 39)) | (1 << (LogoParser.T__54 - 39)) | (1 << (LogoParser.T__55 - 39)) | (1 << (LogoParser.T__56 - 39)) | (1 << (LogoParser.T__57 - 39)) | (1 << (LogoParser.T__58 - 39)) | (1 << (LogoParser.T__59 - 39)) | (1 << (LogoParser.T__60 - 39)) | (1 << (LogoParser.T__61 - 39)) | (1 << (LogoParser.T__62 - 39)) | (1 << (LogoParser.T__63 - 39)) | (1 << (LogoParser.T__64 - 39)) | (1 << (LogoParser.T__65 - 39)) | (1 << (LogoParser.T__66 - 39)) | (1 << (LogoParser.T__67 - 39)) | (1 << (LogoParser.T__68 - 39)) | (1 << (LogoParser.T__69 - 39)))) !== 0) || ((((_la - 71)) & ~0x1f) == 0 && ((1 << (_la - 71)) & ((1 << (LogoParser.T__70 - 71)) | (1 << (LogoParser.T__71 - 71)) | (1 << (LogoParser.T__72 - 71)) | (1 << (LogoParser.T__73 - 71)) | (1 << (LogoParser.T__74 - 71)) | (1 << (LogoParser.T__75 - 71)) | (1 << (LogoParser.T__76 - 71)) | (1 << (LogoParser.T__95 - 71)) | (1 << (LogoParser.T__96 - 71)) | (1 << (LogoParser.T__97 - 71)) | (1 << (LogoParser.T__98 - 71)) | (1 << (LogoParser.T__99 - 71)) | (1 << (LogoParser.T__100 - 71)))) !== 0) || ((((_la - 105)) & ~0x1f) == 0 && ((1 << (_la - 105)) & ((1 << (LogoParser.T__104 - 105)) | (1 << (LogoParser.T__105 - 105)) | (1 << (LogoParser.T__106 - 105)) | (1 << (LogoParser.T__107 - 105)) | (1 << (LogoParser.STRING - 105)))) !== 0)) {
            this.state = 279;
            this.cmd();
            this.state = 284;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
        this.state = 288;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(_la===LogoParser.EOL) {
            this.state = 285;
            this.match(LogoParser.EOL);
            this.state = 290;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
        this.state = 291;
        this.match(LogoParser.T__6);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function IfeContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_ife;
    return this;
}

IfeContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
IfeContext.prototype.constructor = IfeContext;

IfeContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

IfeContext.prototype.block = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(BlockContext);
    } else {
        return this.getTypedRuleContext(BlockContext,i);
    }
};

IfeContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterIfe(this);
	}
};

IfeContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitIfe(this);
	}
};

IfeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitIfe(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.IfeContext = IfeContext;

LogoParser.prototype.ife = function() {

    var localctx = new IfeContext(this, this._ctx, this.state);
    this.enterRule(localctx, 20, LogoParser.RULE_ife);
    try {
        this.state = 302;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,18,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 293;
            this.match(LogoParser.T__7);
            this.state = 294;
            this.expression();
            this.state = 295;
            this.block();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 297;
            this.match(LogoParser.T__7);
            this.state = 298;
            this.expression();
            this.state = 299;
            this.block();
            this.state = 300;
            this.block();
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ExpressionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_expression;
    return this;
}

ExpressionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ExpressionContext.prototype.constructor = ExpressionContext;

ExpressionContext.prototype.number = function() {
    return this.getTypedRuleContext(NumberContext,0);
};

ExpressionContext.prototype.sExpr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(SExprContext);
    } else {
        return this.getTypedRuleContext(SExprContext,i);
    }
};

ExpressionContext.prototype.comparisonOperator = function() {
    return this.getTypedRuleContext(ComparisonOperatorContext,0);
};

ExpressionContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterExpression(this);
	}
};

ExpressionContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitExpression(this);
	}
};

ExpressionContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitExpression(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.ExpressionContext = ExpressionContext;

LogoParser.prototype.expression = function() {

    var localctx = new ExpressionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 22, LogoParser.RULE_expression);
    try {
        this.state = 311;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,20,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 304;
            this.number();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 305;
            this.sExpr();
            this.state = 309;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,19,this._ctx);
            if(la_===1) {
                this.state = 306;
                this.comparisonOperator();
                this.state = 307;
                this.sExpr();

            }
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ComparisonOperatorContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_comparisonOperator;
    return this;
}

ComparisonOperatorContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ComparisonOperatorContext.prototype.constructor = ComparisonOperatorContext;


ComparisonOperatorContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterComparisonOperator(this);
	}
};

ComparisonOperatorContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitComparisonOperator(this);
	}
};

ComparisonOperatorContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitComparisonOperator(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.ComparisonOperatorContext = ComparisonOperatorContext;

LogoParser.prototype.comparisonOperator = function() {

    var localctx = new ComparisonOperatorContext(this, this._ctx, this.state);
    this.enterRule(localctx, 24, LogoParser.RULE_comparisonOperator);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 313;
        _la = this._input.LA(1);
        if(!((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoParser.T__8) | (1 << LogoParser.T__9) | (1 << LogoParser.T__10) | (1 << LogoParser.T__11) | (1 << LogoParser.T__12) | (1 << LogoParser.T__13))) !== 0))) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SExprContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_sExpr;
    return this;
}

SExprContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SExprContext.prototype.constructor = SExprContext;

SExprContext.prototype.term = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(TermContext);
    } else {
        return this.getTypedRuleContext(TermContext,i);
    }
};

SExprContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterSExpr(this);
	}
};

SExprContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitSExpr(this);
	}
};

SExprContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitSExpr(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.SExprContext = SExprContext;

LogoParser.prototype.sExpr = function() {

    var localctx = new SExprContext(this, this._ctx, this.state);
    this.enterRule(localctx, 26, LogoParser.RULE_sExpr);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 315;
        this.term();
        this.state = 320;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input,21,this._ctx)
        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
            if(_alt===1) {
                this.state = 316;
                _la = this._input.LA(1);
                if(!((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoParser.T__14) | (1 << LogoParser.T__15) | (1 << LogoParser.T__16))) !== 0))) {
                this._errHandler.recoverInline(this);
                }
                else {
                    this.consume();
                }
                this.state = 317;
                this.term(); 
            }
            this.state = 322;
            this._errHandler.sync(this);
            _alt = this._interp.adaptivePredict(this._input,21,this._ctx);
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function TermContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_term;
    return this;
}

TermContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
TermContext.prototype.constructor = TermContext;

TermContext.prototype.factor = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(FactorContext);
    } else {
        return this.getTypedRuleContext(FactorContext,i);
    }
};

TermContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterTerm(this);
	}
};

TermContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitTerm(this);
	}
};

TermContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitTerm(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.TermContext = TermContext;

LogoParser.prototype.term = function() {

    var localctx = new TermContext(this, this._ctx, this.state);
    this.enterRule(localctx, 28, LogoParser.RULE_term);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 323;
        this.factor();
        this.state = 328;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input,22,this._ctx)
        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
            if(_alt===1) {
                this.state = 324;
                _la = this._input.LA(1);
                if(!((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoParser.T__17) | (1 << LogoParser.T__18) | (1 << LogoParser.T__19))) !== 0))) {
                this._errHandler.recoverInline(this);
                }
                else {
                    this.consume();
                }
                this.state = 325;
                this.factor(); 
            }
            this.state = 330;
            this._errHandler.sync(this);
            _alt = this._interp.adaptivePredict(this._input,22,this._ctx);
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function FactorContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_factor;
    return this;
}

FactorContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
FactorContext.prototype.constructor = FactorContext;

FactorContext.prototype.nsFact = function() {
    return this.getTypedRuleContext(NsFactContext,0);
};

FactorContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterFactor(this);
	}
};

FactorContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitFactor(this);
	}
};

FactorContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitFactor(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.FactorContext = FactorContext;

LogoParser.prototype.factor = function() {

    var localctx = new FactorContext(this, this._ctx, this.state);
    this.enterRule(localctx, 30, LogoParser.RULE_factor);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 332;
        _la = this._input.LA(1);
        if(_la===LogoParser.T__14 || _la===LogoParser.T__15) {
            this.state = 331;
            _la = this._input.LA(1);
            if(!(_la===LogoParser.T__14 || _la===LogoParser.T__15)) {
            this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
        }

        this.state = 334;
        this.nsFact();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function NsFactContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_nsFact;
    return this;
}

NsFactContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
NsFactContext.prototype.constructor = NsFactContext;

NsFactContext.prototype.number = function() {
    return this.getTypedRuleContext(NumberContext,0);
};

NsFactContext.prototype.deref = function() {
    return this.getTypedRuleContext(DerefContext,0);
};

NsFactContext.prototype.func = function() {
    return this.getTypedRuleContext(FuncContext,0);
};

NsFactContext.prototype.LPAREN = function() {
    return this.getToken(LogoParser.LPAREN, 0);
};

NsFactContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

NsFactContext.prototype.RPAREN = function() {
    return this.getToken(LogoParser.RPAREN, 0);
};

NsFactContext.prototype.factor = function() {
    return this.getTypedRuleContext(FactorContext,0);
};

NsFactContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterNsFact(this);
	}
};

NsFactContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitNsFact(this);
	}
};

NsFactContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitNsFact(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.NsFactContext = NsFactContext;

LogoParser.prototype.nsFact = function() {

    var localctx = new NsFactContext(this, this._ctx, this.state);
    this.enterRule(localctx, 32, LogoParser.RULE_nsFact);
    try {
        this.state = 347;
        switch(this._input.LA(1)) {
        case LogoParser.T__2:
        case LogoParser.T__77:
        case LogoParser.T__78:
        case LogoParser.T__79:
        case LogoParser.T__80:
        case LogoParser.T__81:
        case LogoParser.T__82:
        case LogoParser.T__83:
        case LogoParser.T__84:
        case LogoParser.T__85:
        case LogoParser.T__86:
        case LogoParser.T__87:
        case LogoParser.T__88:
        case LogoParser.T__89:
        case LogoParser.T__90:
        case LogoParser.T__91:
        case LogoParser.T__92:
        case LogoParser.T__93:
        case LogoParser.T__94:
        case LogoParser.T__102:
        case LogoParser.T__103:
        case LogoParser.NUMBER:
            this.enterOuterAlt(localctx, 1);
            this.state = 339;
            switch(this._input.LA(1)) {
            case LogoParser.T__102:
            case LogoParser.T__103:
            case LogoParser.NUMBER:
                this.state = 336;
                this.number();
                break;
            case LogoParser.T__2:
                this.state = 337;
                this.deref();
                break;
            case LogoParser.T__77:
            case LogoParser.T__78:
            case LogoParser.T__79:
            case LogoParser.T__80:
            case LogoParser.T__81:
            case LogoParser.T__82:
            case LogoParser.T__83:
            case LogoParser.T__84:
            case LogoParser.T__85:
            case LogoParser.T__86:
            case LogoParser.T__87:
            case LogoParser.T__88:
            case LogoParser.T__89:
            case LogoParser.T__90:
            case LogoParser.T__91:
            case LogoParser.T__92:
            case LogoParser.T__93:
            case LogoParser.T__94:
                this.state = 338;
                this.func();
                break;
            default:
                throw new antlr4.error.NoViableAltException(this);
            }
            break;
        case LogoParser.LPAREN:
            this.enterOuterAlt(localctx, 2);
            this.state = 341;
            this.match(LogoParser.LPAREN);
            this.state = 342;
            this.expression();
            this.state = 343;
            this.match(LogoParser.RPAREN);
            break;
        case LogoParser.T__20:
            this.enterOuterAlt(localctx, 3);
            this.state = 345;
            this.match(LogoParser.T__20);
            this.state = 346;
            this.factor();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ValueContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_value;
    return this;
}

ValueContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ValueContext.prototype.constructor = ValueContext;

ValueContext.prototype.STRINGLITERAL = function() {
    return this.getToken(LogoParser.STRINGLITERAL, 0);
};

ValueContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

ValueContext.prototype.deref = function() {
    return this.getTypedRuleContext(DerefContext,0);
};

ValueContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterValue(this);
	}
};

ValueContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitValue(this);
	}
};

ValueContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitValue(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.ValueContext = ValueContext;

LogoParser.prototype.value = function() {

    var localctx = new ValueContext(this, this._ctx, this.state);
    this.enterRule(localctx, 34, LogoParser.RULE_value);
    try {
        this.state = 352;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,26,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 349;
            this.match(LogoParser.STRINGLITERAL);
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 350;
            this.expression();
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 351;
            this.deref();
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function DerefContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_deref;
    return this;
}

DerefContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
DerefContext.prototype.constructor = DerefContext;

DerefContext.prototype.name = function() {
    return this.getTypedRuleContext(NameContext,0);
};

DerefContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterDeref(this);
	}
};

DerefContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitDeref(this);
	}
};

DerefContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitDeref(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.DerefContext = DerefContext;

LogoParser.prototype.deref = function() {

    var localctx = new DerefContext(this, this._ctx, this.state);
    this.enterRule(localctx, 36, LogoParser.RULE_deref);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 354;
        this.match(LogoParser.T__2);
        this.state = 355;
        this.name();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ColornameContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_colorname;
    return this;
}

ColornameContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ColornameContext.prototype.constructor = ColornameContext;


ColornameContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterColorname(this);
	}
};

ColornameContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitColorname(this);
	}
};

ColornameContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitColorname(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.ColornameContext = ColornameContext;

LogoParser.prototype.colorname = function() {

    var localctx = new ColornameContext(this, this._ctx, this.state);
    this.enterRule(localctx, 38, LogoParser.RULE_colorname);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 357;
        _la = this._input.LA(1);
        if(!(((((_la - 22)) & ~0x1f) == 0 && ((1 << (_la - 22)) & ((1 << (LogoParser.T__21 - 22)) | (1 << (LogoParser.T__22 - 22)) | (1 << (LogoParser.T__23 - 22)) | (1 << (LogoParser.T__24 - 22)) | (1 << (LogoParser.T__25 - 22)) | (1 << (LogoParser.T__26 - 22)) | (1 << (LogoParser.T__27 - 22)) | (1 << (LogoParser.T__28 - 22)) | (1 << (LogoParser.T__29 - 22)) | (1 << (LogoParser.T__30 - 22)) | (1 << (LogoParser.T__31 - 22)) | (1 << (LogoParser.T__32 - 22)) | (1 << (LogoParser.T__33 - 22)) | (1 << (LogoParser.T__34 - 22)) | (1 << (LogoParser.T__35 - 22)) | (1 << (LogoParser.T__36 - 22)) | (1 << (LogoParser.T__37 - 22)))) !== 0))) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function RgbContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_rgb;
    return this;
}

RgbContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
RgbContext.prototype.constructor = RgbContext;

RgbContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

RgbContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterRgb(this);
	}
};

RgbContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitRgb(this);
	}
};

RgbContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitRgb(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.RgbContext = RgbContext;

LogoParser.prototype.rgb = function() {

    var localctx = new RgbContext(this, this._ctx, this.state);
    this.enterRule(localctx, 40, LogoParser.RULE_rgb);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 359;
        this.match(LogoParser.T__5);
        this.state = 360;
        this.expression();
        this.state = 361;
        this.expression();
        this.state = 362;
        this.expression();
        this.state = 363;
        this.match(LogoParser.T__6);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ColornumberContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_colornumber;
    return this;
}

ColornumberContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ColornumberContext.prototype.constructor = ColornumberContext;

ColornumberContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

ColornumberContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterColornumber(this);
	}
};

ColornumberContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitColornumber(this);
	}
};

ColornumberContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitColornumber(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.ColornumberContext = ColornumberContext;

LogoParser.prototype.colornumber = function() {

    var localctx = new ColornumberContext(this, this._ctx, this.state);
    this.enterRule(localctx, 42, LogoParser.RULE_colornumber);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 365;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function MakeContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_make;
    return this;
}

MakeContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
MakeContext.prototype.constructor = MakeContext;

MakeContext.prototype.STRINGLITERAL = function() {
    return this.getToken(LogoParser.STRINGLITERAL, 0);
};

MakeContext.prototype.value = function() {
    return this.getTypedRuleContext(ValueContext,0);
};

MakeContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterMake(this);
	}
};

MakeContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitMake(this);
	}
};

MakeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitMake(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.MakeContext = MakeContext;

LogoParser.prototype.make = function() {

    var localctx = new MakeContext(this, this._ctx, this.state);
    this.enterRule(localctx, 44, LogoParser.RULE_make);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 367;
        this.match(LogoParser.T__38);
        this.state = 368;
        this.match(LogoParser.STRINGLITERAL);
        this.state = 369;
        this.value();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function PrintContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_print;
    return this;
}

PrintContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
PrintContext.prototype.constructor = PrintContext;

PrintContext.prototype.value = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ValueContext);
    } else {
        return this.getTypedRuleContext(ValueContext,i);
    }
};

PrintContext.prototype.quotedstring = function() {
    return this.getTypedRuleContext(QuotedstringContext,0);
};

PrintContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterPrint(this);
	}
};

PrintContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitPrint(this);
	}
};

PrintContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitPrint(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.PrintContext = PrintContext;

LogoParser.prototype.print = function() {

    var localctx = new PrintContext(this, this._ctx, this.state);
    this.enterRule(localctx, 46, LogoParser.RULE_print);
    var _la = 0; // Token type
    try {
        this.state = 384;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,28,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 371;
            _la = this._input.LA(1);
            if(!(_la===LogoParser.T__39 || _la===LogoParser.T__40)) {
            this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 372;
            this.value();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 373;
            _la = this._input.LA(1);
            if(!(_la===LogoParser.T__39 || _la===LogoParser.T__40)) {
            this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 374;
            this.match(LogoParser.T__5);
            this.state = 376; 
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            do {
                this.state = 375;
                this.value();
                this.state = 378; 
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            } while((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoParser.T__2) | (1 << LogoParser.T__14) | (1 << LogoParser.T__15) | (1 << LogoParser.T__20))) !== 0) || ((((_la - 78)) & ~0x1f) == 0 && ((1 << (_la - 78)) & ((1 << (LogoParser.T__77 - 78)) | (1 << (LogoParser.T__78 - 78)) | (1 << (LogoParser.T__79 - 78)) | (1 << (LogoParser.T__80 - 78)) | (1 << (LogoParser.T__81 - 78)) | (1 << (LogoParser.T__82 - 78)) | (1 << (LogoParser.T__83 - 78)) | (1 << (LogoParser.T__84 - 78)) | (1 << (LogoParser.T__85 - 78)) | (1 << (LogoParser.T__86 - 78)) | (1 << (LogoParser.T__87 - 78)) | (1 << (LogoParser.T__88 - 78)) | (1 << (LogoParser.T__89 - 78)) | (1 << (LogoParser.T__90 - 78)) | (1 << (LogoParser.T__91 - 78)) | (1 << (LogoParser.T__92 - 78)) | (1 << (LogoParser.T__93 - 78)) | (1 << (LogoParser.T__94 - 78)) | (1 << (LogoParser.T__102 - 78)) | (1 << (LogoParser.T__103 - 78)) | (1 << (LogoParser.STRINGLITERAL - 78)))) !== 0) || _la===LogoParser.LPAREN || _la===LogoParser.NUMBER);
            this.state = 380;
            this.match(LogoParser.T__6);
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 382;
            _la = this._input.LA(1);
            if(!(_la===LogoParser.T__39 || _la===LogoParser.T__40)) {
            this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 383;
            this.quotedstring();
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function QuotedstringContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_quotedstring;
    return this;
}

QuotedstringContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
QuotedstringContext.prototype.constructor = QuotedstringContext;

QuotedstringContext.prototype.quotedstring = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(QuotedstringContext);
    } else {
        return this.getTypedRuleContext(QuotedstringContext,i);
    }
};

QuotedstringContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterQuotedstring(this);
	}
};

QuotedstringContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitQuotedstring(this);
	}
};

QuotedstringContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitQuotedstring(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.QuotedstringContext = QuotedstringContext;

LogoParser.prototype.quotedstring = function() {

    var localctx = new QuotedstringContext(this, this._ctx, this.state);
    this.enterRule(localctx, 48, LogoParser.RULE_quotedstring);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 386;
        this.match(LogoParser.T__5);
        this.state = 391;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LogoParser.T__0) | (1 << LogoParser.T__1) | (1 << LogoParser.T__2) | (1 << LogoParser.T__3) | (1 << LogoParser.T__4) | (1 << LogoParser.T__5) | (1 << LogoParser.T__7) | (1 << LogoParser.T__8) | (1 << LogoParser.T__9) | (1 << LogoParser.T__10) | (1 << LogoParser.T__11) | (1 << LogoParser.T__12) | (1 << LogoParser.T__13) | (1 << LogoParser.T__14) | (1 << LogoParser.T__15) | (1 << LogoParser.T__16) | (1 << LogoParser.T__17) | (1 << LogoParser.T__18) | (1 << LogoParser.T__19) | (1 << LogoParser.T__20) | (1 << LogoParser.T__21) | (1 << LogoParser.T__22) | (1 << LogoParser.T__23) | (1 << LogoParser.T__24) | (1 << LogoParser.T__25) | (1 << LogoParser.T__26) | (1 << LogoParser.T__27) | (1 << LogoParser.T__28) | (1 << LogoParser.T__29) | (1 << LogoParser.T__30))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (LogoParser.T__31 - 32)) | (1 << (LogoParser.T__32 - 32)) | (1 << (LogoParser.T__33 - 32)) | (1 << (LogoParser.T__34 - 32)) | (1 << (LogoParser.T__35 - 32)) | (1 << (LogoParser.T__36 - 32)) | (1 << (LogoParser.T__37 - 32)) | (1 << (LogoParser.T__38 - 32)) | (1 << (LogoParser.T__39 - 32)) | (1 << (LogoParser.T__40 - 32)) | (1 << (LogoParser.T__41 - 32)) | (1 << (LogoParser.T__42 - 32)) | (1 << (LogoParser.T__43 - 32)) | (1 << (LogoParser.T__44 - 32)) | (1 << (LogoParser.T__45 - 32)) | (1 << (LogoParser.T__46 - 32)) | (1 << (LogoParser.T__47 - 32)) | (1 << (LogoParser.T__48 - 32)) | (1 << (LogoParser.T__49 - 32)) | (1 << (LogoParser.T__50 - 32)) | (1 << (LogoParser.T__51 - 32)) | (1 << (LogoParser.T__52 - 32)) | (1 << (LogoParser.T__53 - 32)) | (1 << (LogoParser.T__54 - 32)) | (1 << (LogoParser.T__55 - 32)) | (1 << (LogoParser.T__56 - 32)) | (1 << (LogoParser.T__57 - 32)) | (1 << (LogoParser.T__58 - 32)) | (1 << (LogoParser.T__59 - 32)) | (1 << (LogoParser.T__60 - 32)) | (1 << (LogoParser.T__61 - 32)) | (1 << (LogoParser.T__62 - 32)))) !== 0) || ((((_la - 64)) & ~0x1f) == 0 && ((1 << (_la - 64)) & ((1 << (LogoParser.T__63 - 64)) | (1 << (LogoParser.T__64 - 64)) | (1 << (LogoParser.T__65 - 64)) | (1 << (LogoParser.T__66 - 64)) | (1 << (LogoParser.T__67 - 64)) | (1 << (LogoParser.T__68 - 64)) | (1 << (LogoParser.T__69 - 64)) | (1 << (LogoParser.T__70 - 64)) | (1 << (LogoParser.T__71 - 64)) | (1 << (LogoParser.T__72 - 64)) | (1 << (LogoParser.T__73 - 64)) | (1 << (LogoParser.T__74 - 64)) | (1 << (LogoParser.T__75 - 64)) | (1 << (LogoParser.T__76 - 64)) | (1 << (LogoParser.T__77 - 64)) | (1 << (LogoParser.T__78 - 64)) | (1 << (LogoParser.T__79 - 64)) | (1 << (LogoParser.T__80 - 64)) | (1 << (LogoParser.T__81 - 64)) | (1 << (LogoParser.T__82 - 64)) | (1 << (LogoParser.T__83 - 64)) | (1 << (LogoParser.T__84 - 64)) | (1 << (LogoParser.T__85 - 64)) | (1 << (LogoParser.T__86 - 64)) | (1 << (LogoParser.T__87 - 64)) | (1 << (LogoParser.T__88 - 64)) | (1 << (LogoParser.T__89 - 64)) | (1 << (LogoParser.T__90 - 64)) | (1 << (LogoParser.T__91 - 64)) | (1 << (LogoParser.T__92 - 64)) | (1 << (LogoParser.T__93 - 64)) | (1 << (LogoParser.T__94 - 64)))) !== 0) || ((((_la - 96)) & ~0x1f) == 0 && ((1 << (_la - 96)) & ((1 << (LogoParser.T__95 - 96)) | (1 << (LogoParser.T__96 - 96)) | (1 << (LogoParser.T__97 - 96)) | (1 << (LogoParser.T__98 - 96)) | (1 << (LogoParser.T__99 - 96)) | (1 << (LogoParser.T__100 - 96)) | (1 << (LogoParser.T__101 - 96)) | (1 << (LogoParser.T__102 - 96)) | (1 << (LogoParser.T__103 - 96)) | (1 << (LogoParser.T__104 - 96)) | (1 << (LogoParser.T__105 - 96)) | (1 << (LogoParser.T__106 - 96)) | (1 << (LogoParser.T__107 - 96)) | (1 << (LogoParser.STRINGLITERAL - 96)) | (1 << (LogoParser.STRING - 96)) | (1 << (LogoParser.LPAREN - 96)) | (1 << (LogoParser.RPAREN - 96)) | (1 << (LogoParser.NUMBER - 96)) | (1 << (LogoParser.COMMENT - 96)) | (1 << (LogoParser.EOL - 96)) | (1 << (LogoParser.WS - 96)))) !== 0)) {
            this.state = 389;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,29,this._ctx);
            switch(la_) {
            case 1:
                this.state = 387;
                this.quotedstring();
                break;

            case 2:
                this.state = 388;
                _la = this._input.LA(1);
                if(_la<=0 || _la===LogoParser.T__6) {
                this._errHandler.recoverInline(this);
                }
                else {
                    this.consume();
                }
                break;

            }
            this.state = 393;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
        this.state = 394;
        this.match(LogoParser.T__6);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function NameContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_name;
    return this;
}

NameContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
NameContext.prototype.constructor = NameContext;

NameContext.prototype.STRING = function() {
    return this.getToken(LogoParser.STRING, 0);
};

NameContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterName(this);
	}
};

NameContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitName(this);
	}
};

NameContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitName(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.NameContext = NameContext;

LogoParser.prototype.name = function() {

    var localctx = new NameContext(this, this._ctx, this.state);
    this.enterRule(localctx, 50, LogoParser.RULE_name);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 396;
        this.match(LogoParser.STRING);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function FdContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_fd;
    return this;
}

FdContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
FdContext.prototype.constructor = FdContext;

FdContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

FdContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterFd(this);
	}
};

FdContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitFd(this);
	}
};

FdContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitFd(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.FdContext = FdContext;

LogoParser.prototype.fd = function() {

    var localctx = new FdContext(this, this._ctx, this.state);
    this.enterRule(localctx, 52, LogoParser.RULE_fd);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 398;
        _la = this._input.LA(1);
        if(!(_la===LogoParser.T__41 || _la===LogoParser.T__42)) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
        this.state = 399;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function BkContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_bk;
    return this;
}

BkContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
BkContext.prototype.constructor = BkContext;

BkContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

BkContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterBk(this);
	}
};

BkContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitBk(this);
	}
};

BkContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitBk(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.BkContext = BkContext;

LogoParser.prototype.bk = function() {

    var localctx = new BkContext(this, this._ctx, this.state);
    this.enterRule(localctx, 54, LogoParser.RULE_bk);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 401;
        _la = this._input.LA(1);
        if(!(((((_la - 44)) & ~0x1f) == 0 && ((1 << (_la - 44)) & ((1 << (LogoParser.T__43 - 44)) | (1 << (LogoParser.T__44 - 44)) | (1 << (LogoParser.T__45 - 44)))) !== 0))) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
        this.state = 402;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function RtContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_rt;
    return this;
}

RtContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
RtContext.prototype.constructor = RtContext;

RtContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

RtContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterRt(this);
	}
};

RtContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitRt(this);
	}
};

RtContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitRt(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.RtContext = RtContext;

LogoParser.prototype.rt = function() {

    var localctx = new RtContext(this, this._ctx, this.state);
    this.enterRule(localctx, 56, LogoParser.RULE_rt);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 404;
        _la = this._input.LA(1);
        if(!(_la===LogoParser.T__46 || _la===LogoParser.T__47)) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
        this.state = 405;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function LtContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_lt;
    return this;
}

LtContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LtContext.prototype.constructor = LtContext;

LtContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

LtContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterLt(this);
	}
};

LtContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitLt(this);
	}
};

LtContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitLt(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.LtContext = LtContext;

LogoParser.prototype.lt = function() {

    var localctx = new LtContext(this, this._ctx, this.state);
    this.enterRule(localctx, 58, LogoParser.RULE_lt);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 407;
        _la = this._input.LA(1);
        if(!(_la===LogoParser.T__48 || _la===LogoParser.T__49)) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
        this.state = 408;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function CsContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_cs;
    return this;
}

CsContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
CsContext.prototype.constructor = CsContext;


CsContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterCs(this);
	}
};

CsContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitCs(this);
	}
};

CsContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitCs(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.CsContext = CsContext;

LogoParser.prototype.cs = function() {

    var localctx = new CsContext(this, this._ctx, this.state);
    this.enterRule(localctx, 60, LogoParser.RULE_cs);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 410;
        _la = this._input.LA(1);
        if(!(_la===LogoParser.T__50 || _la===LogoParser.T__51)) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function RetryContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_retry;
    return this;
}

RetryContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
RetryContext.prototype.constructor = RetryContext;


RetryContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterRetry(this);
	}
};

RetryContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitRetry(this);
	}
};

RetryContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitRetry(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.RetryContext = RetryContext;

LogoParser.prototype.retry = function() {

    var localctx = new RetryContext(this, this._ctx, this.state);
    this.enterRule(localctx, 62, LogoParser.RULE_retry);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 412;
        this.match(LogoParser.T__52);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function NextContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_next;
    return this;
}

NextContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
NextContext.prototype.constructor = NextContext;


NextContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterNext(this);
	}
};

NextContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitNext(this);
	}
};

NextContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitNext(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.NextContext = NextContext;

LogoParser.prototype.next = function() {

    var localctx = new NextContext(this, this._ctx, this.state);
    this.enterRule(localctx, 64, LogoParser.RULE_next);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 414;
        this.match(LogoParser.T__53);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function LastContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_last;
    return this;
}

LastContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LastContext.prototype.constructor = LastContext;


LastContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterLast(this);
	}
};

LastContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitLast(this);
	}
};

LastContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitLast(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.LastContext = LastContext;

LogoParser.prototype.last = function() {

    var localctx = new LastContext(this, this._ctx, this.state);
    this.enterRule(localctx, 66, LogoParser.RULE_last);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 416;
        this.match(LogoParser.T__54);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function CtContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_ct;
    return this;
}

CtContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
CtContext.prototype.constructor = CtContext;


CtContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterCt(this);
	}
};

CtContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitCt(this);
	}
};

CtContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitCt(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.CtContext = CtContext;

LogoParser.prototype.ct = function() {

    var localctx = new CtContext(this, this._ctx, this.state);
    this.enterRule(localctx, 68, LogoParser.RULE_ct);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 418;
        this.match(LogoParser.T__55);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function PuContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_pu;
    return this;
}

PuContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
PuContext.prototype.constructor = PuContext;


PuContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterPu(this);
	}
};

PuContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitPu(this);
	}
};

PuContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitPu(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.PuContext = PuContext;

LogoParser.prototype.pu = function() {

    var localctx = new PuContext(this, this._ctx, this.state);
    this.enterRule(localctx, 70, LogoParser.RULE_pu);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 420;
        _la = this._input.LA(1);
        if(!(_la===LogoParser.T__56 || _la===LogoParser.T__57)) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function PdContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_pd;
    return this;
}

PdContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
PdContext.prototype.constructor = PdContext;


PdContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterPd(this);
	}
};

PdContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitPd(this);
	}
};

PdContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitPd(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.PdContext = PdContext;

LogoParser.prototype.pd = function() {

    var localctx = new PdContext(this, this._ctx, this.state);
    this.enterRule(localctx, 72, LogoParser.RULE_pd);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 422;
        _la = this._input.LA(1);
        if(!(_la===LogoParser.T__58 || _la===LogoParser.T__59)) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function PeContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_pe;
    return this;
}

PeContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
PeContext.prototype.constructor = PeContext;


PeContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterPe(this);
	}
};

PeContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitPe(this);
	}
};

PeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitPe(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.PeContext = PeContext;

LogoParser.prototype.pe = function() {

    var localctx = new PeContext(this, this._ctx, this.state);
    this.enterRule(localctx, 74, LogoParser.RULE_pe);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 424;
        _la = this._input.LA(1);
        if(!(_la===LogoParser.T__60 || _la===LogoParser.T__61)) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function PptContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_ppt;
    return this;
}

PptContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
PptContext.prototype.constructor = PptContext;


PptContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterPpt(this);
	}
};

PptContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitPpt(this);
	}
};

PptContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitPpt(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.PptContext = PptContext;

LogoParser.prototype.ppt = function() {

    var localctx = new PptContext(this, this._ctx, this.state);
    this.enterRule(localctx, 76, LogoParser.RULE_ppt);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 426;
        _la = this._input.LA(1);
        if(!(_la===LogoParser.T__62 || _la===LogoParser.T__63)) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function HtContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_ht;
    return this;
}

HtContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
HtContext.prototype.constructor = HtContext;


HtContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterHt(this);
	}
};

HtContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitHt(this);
	}
};

HtContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitHt(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.HtContext = HtContext;

LogoParser.prototype.ht = function() {

    var localctx = new HtContext(this, this._ctx, this.state);
    this.enterRule(localctx, 78, LogoParser.RULE_ht);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 428;
        _la = this._input.LA(1);
        if(!(_la===LogoParser.T__64 || _la===LogoParser.T__65)) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function StContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_st;
    return this;
}

StContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
StContext.prototype.constructor = StContext;


StContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterSt(this);
	}
};

StContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitSt(this);
	}
};

StContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitSt(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.StContext = StContext;

LogoParser.prototype.st = function() {

    var localctx = new StContext(this, this._ctx, this.state);
    this.enterRule(localctx, 80, LogoParser.RULE_st);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 430;
        _la = this._input.LA(1);
        if(!(_la===LogoParser.T__66 || _la===LogoParser.T__67)) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SetpcContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_setpc;
    return this;
}

SetpcContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SetpcContext.prototype.constructor = SetpcContext;

SetpcContext.prototype.colornumber = function() {
    return this.getTypedRuleContext(ColornumberContext,0);
};

SetpcContext.prototype.rgb = function() {
    return this.getTypedRuleContext(RgbContext,0);
};

SetpcContext.prototype.colorname = function() {
    return this.getTypedRuleContext(ColornameContext,0);
};

SetpcContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterSetpc(this);
	}
};

SetpcContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitSetpc(this);
	}
};

SetpcContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitSetpc(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.SetpcContext = SetpcContext;

LogoParser.prototype.setpc = function() {

    var localctx = new SetpcContext(this, this._ctx, this.state);
    this.enterRule(localctx, 82, LogoParser.RULE_setpc);
    var _la = 0; // Token type
    try {
        this.state = 438;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,31,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 432;
            _la = this._input.LA(1);
            if(!(_la===LogoParser.T__68 || _la===LogoParser.T__69)) {
            this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 433;
            this.colornumber();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 434;
            _la = this._input.LA(1);
            if(!(_la===LogoParser.T__68 || _la===LogoParser.T__69)) {
            this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 435;
            this.rgb();
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 436;
            _la = this._input.LA(1);
            if(!(_la===LogoParser.T__68 || _la===LogoParser.T__69)) {
            this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 437;
            this.colorname();
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SetscContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_setsc;
    return this;
}

SetscContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SetscContext.prototype.constructor = SetscContext;

SetscContext.prototype.rgb = function() {
    return this.getTypedRuleContext(RgbContext,0);
};

SetscContext.prototype.colorname = function() {
    return this.getTypedRuleContext(ColornameContext,0);
};

SetscContext.prototype.colornumber = function() {
    return this.getTypedRuleContext(ColornumberContext,0);
};

SetscContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterSetsc(this);
	}
};

SetscContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitSetsc(this);
	}
};

SetscContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitSetsc(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.SetscContext = SetscContext;

LogoParser.prototype.setsc = function() {

    var localctx = new SetscContext(this, this._ctx, this.state);
    this.enterRule(localctx, 84, LogoParser.RULE_setsc);
    var _la = 0; // Token type
    try {
        this.state = 446;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,32,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 440;
            _la = this._input.LA(1);
            if(!(_la===LogoParser.T__70 || _la===LogoParser.T__71)) {
            this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 441;
            this.rgb();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 442;
            _la = this._input.LA(1);
            if(!(_la===LogoParser.T__70 || _la===LogoParser.T__71)) {
            this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 443;
            this.colorname();
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 444;
            _la = this._input.LA(1);
            if(!(_la===LogoParser.T__70 || _la===LogoParser.T__71)) {
            this._errHandler.recoverInline(this);
            }
            else {
                this.consume();
            }
            this.state = 445;
            this.colornumber();
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function HomeContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_home;
    return this;
}

HomeContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
HomeContext.prototype.constructor = HomeContext;


HomeContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterHome(this);
	}
};

HomeContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitHome(this);
	}
};

HomeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitHome(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.HomeContext = HomeContext;

LogoParser.prototype.home = function() {

    var localctx = new HomeContext(this, this._ctx, this.state);
    this.enterRule(localctx, 86, LogoParser.RULE_home);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 448;
        this.match(LogoParser.T__72);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function StopContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_stop;
    return this;
}

StopContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
StopContext.prototype.constructor = StopContext;


StopContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterStop(this);
	}
};

StopContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitStop(this);
	}
};

StopContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitStop(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.StopContext = StopContext;

LogoParser.prototype.stop = function() {

    var localctx = new StopContext(this, this._ctx, this.state);
    this.enterRule(localctx, 88, LogoParser.RULE_stop);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 450;
        this.match(LogoParser.T__73);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SetxyContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_setxy;
    return this;
}

SetxyContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SetxyContext.prototype.constructor = SetxyContext;

SetxyContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

SetxyContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterSetxy(this);
	}
};

SetxyContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitSetxy(this);
	}
};

SetxyContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitSetxy(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.SetxyContext = SetxyContext;

LogoParser.prototype.setxy = function() {

    var localctx = new SetxyContext(this, this._ctx, this.state);
    this.enterRule(localctx, 90, LogoParser.RULE_setxy);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 452;
        this.match(LogoParser.T__74);
        this.state = 453;
        this.expression();
        this.state = 454;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SetxContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_setx;
    return this;
}

SetxContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SetxContext.prototype.constructor = SetxContext;

SetxContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

SetxContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterSetx(this);
	}
};

SetxContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitSetx(this);
	}
};

SetxContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitSetx(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.SetxContext = SetxContext;

LogoParser.prototype.setx = function() {

    var localctx = new SetxContext(this, this._ctx, this.state);
    this.enterRule(localctx, 92, LogoParser.RULE_setx);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 456;
        this.match(LogoParser.T__75);
        this.state = 457;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SetyContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_sety;
    return this;
}

SetyContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SetyContext.prototype.constructor = SetyContext;

SetyContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

SetyContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterSety(this);
	}
};

SetyContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitSety(this);
	}
};

SetyContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitSety(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.SetyContext = SetyContext;

LogoParser.prototype.sety = function() {

    var localctx = new SetyContext(this, this._ctx, this.state);
    this.enterRule(localctx, 94, LogoParser.RULE_sety);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 459;
        this.match(LogoParser.T__76);
        this.state = 460;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function RandomContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_random;
    return this;
}

RandomContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
RandomContext.prototype.constructor = RandomContext;

RandomContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

RandomContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterRandom(this);
	}
};

RandomContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitRandom(this);
	}
};

RandomContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitRandom(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.RandomContext = RandomContext;

LogoParser.prototype.random = function() {

    var localctx = new RandomContext(this, this._ctx, this.state);
    this.enterRule(localctx, 96, LogoParser.RULE_random);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 462;
        _la = this._input.LA(1);
        if(!(((((_la - 78)) & ~0x1f) == 0 && ((1 << (_la - 78)) & ((1 << (LogoParser.T__77 - 78)) | (1 << (LogoParser.T__78 - 78)) | (1 << (LogoParser.T__79 - 78)))) !== 0))) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
        this.state = 463;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SinContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_sin;
    return this;
}

SinContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SinContext.prototype.constructor = SinContext;

SinContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

SinContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterSin(this);
	}
};

SinContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitSin(this);
	}
};

SinContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitSin(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.SinContext = SinContext;

LogoParser.prototype.sin = function() {

    var localctx = new SinContext(this, this._ctx, this.state);
    this.enterRule(localctx, 98, LogoParser.RULE_sin);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 465;
        this.match(LogoParser.T__80);
        this.state = 466;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function CosContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_cos;
    return this;
}

CosContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
CosContext.prototype.constructor = CosContext;

CosContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

CosContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterCos(this);
	}
};

CosContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitCos(this);
	}
};

CosContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitCos(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.CosContext = CosContext;

LogoParser.prototype.cos = function() {

    var localctx = new CosContext(this, this._ctx, this.state);
    this.enterRule(localctx, 100, LogoParser.RULE_cos);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 468;
        this.match(LogoParser.T__81);
        this.state = 469;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function TanContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_tan;
    return this;
}

TanContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
TanContext.prototype.constructor = TanContext;

TanContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

TanContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterTan(this);
	}
};

TanContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitTan(this);
	}
};

TanContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitTan(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.TanContext = TanContext;

LogoParser.prototype.tan = function() {

    var localctx = new TanContext(this, this._ctx, this.state);
    this.enterRule(localctx, 102, LogoParser.RULE_tan);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 471;
        this.match(LogoParser.T__82);
        this.state = 472;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ArcsinContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_arcsin;
    return this;
}

ArcsinContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ArcsinContext.prototype.constructor = ArcsinContext;

ArcsinContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

ArcsinContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterArcsin(this);
	}
};

ArcsinContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitArcsin(this);
	}
};

ArcsinContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitArcsin(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.ArcsinContext = ArcsinContext;

LogoParser.prototype.arcsin = function() {

    var localctx = new ArcsinContext(this, this._ctx, this.state);
    this.enterRule(localctx, 104, LogoParser.RULE_arcsin);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 474;
        _la = this._input.LA(1);
        if(!(_la===LogoParser.T__83 || _la===LogoParser.T__84)) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
        this.state = 475;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ArccosContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_arccos;
    return this;
}

ArccosContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ArccosContext.prototype.constructor = ArccosContext;

ArccosContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

ArccosContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterArccos(this);
	}
};

ArccosContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitArccos(this);
	}
};

ArccosContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitArccos(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.ArccosContext = ArccosContext;

LogoParser.prototype.arccos = function() {

    var localctx = new ArccosContext(this, this._ctx, this.state);
    this.enterRule(localctx, 106, LogoParser.RULE_arccos);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 477;
        _la = this._input.LA(1);
        if(!(_la===LogoParser.T__85 || _la===LogoParser.T__86)) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
        this.state = 478;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ArctanContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_arctan;
    return this;
}

ArctanContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ArctanContext.prototype.constructor = ArctanContext;

ArctanContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

ArctanContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterArctan(this);
	}
};

ArctanContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitArctan(this);
	}
};

ArctanContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitArctan(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.ArctanContext = ArctanContext;

LogoParser.prototype.arctan = function() {

    var localctx = new ArctanContext(this, this._ctx, this.state);
    this.enterRule(localctx, 108, LogoParser.RULE_arctan);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 480;
        _la = this._input.LA(1);
        if(!(_la===LogoParser.T__87 || _la===LogoParser.T__88)) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
        this.state = 481;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function AbsContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_abs;
    return this;
}

AbsContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
AbsContext.prototype.constructor = AbsContext;

AbsContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

AbsContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterAbs(this);
	}
};

AbsContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitAbs(this);
	}
};

AbsContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitAbs(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.AbsContext = AbsContext;

LogoParser.prototype.abs = function() {

    var localctx = new AbsContext(this, this._ctx, this.state);
    this.enterRule(localctx, 110, LogoParser.RULE_abs);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 483;
        this.match(LogoParser.T__89);
        this.state = 484;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SqrtContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_sqrt;
    return this;
}

SqrtContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SqrtContext.prototype.constructor = SqrtContext;

SqrtContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

SqrtContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterSqrt(this);
	}
};

SqrtContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitSqrt(this);
	}
};

SqrtContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitSqrt(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.SqrtContext = SqrtContext;

LogoParser.prototype.sqrt = function() {

    var localctx = new SqrtContext(this, this._ctx, this.state);
    this.enterRule(localctx, 112, LogoParser.RULE_sqrt);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 486;
        this.match(LogoParser.T__90);
        this.state = 487;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ModContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_mod;
    return this;
}

ModContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ModContext.prototype.constructor = ModContext;

ModContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

ModContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterMod(this);
	}
};

ModContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitMod(this);
	}
};

ModContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitMod(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.ModContext = ModContext;

LogoParser.prototype.mod = function() {

    var localctx = new ModContext(this, this._ctx, this.state);
    this.enterRule(localctx, 114, LogoParser.RULE_mod);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 489;
        this.match(LogoParser.T__91);
        this.state = 490;
        this.expression();
        this.state = 491;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function PowerContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_power;
    return this;
}

PowerContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
PowerContext.prototype.constructor = PowerContext;

PowerContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

PowerContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterPower(this);
	}
};

PowerContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitPower(this);
	}
};

PowerContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitPower(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.PowerContext = PowerContext;

LogoParser.prototype.power = function() {

    var localctx = new PowerContext(this, this._ctx, this.state);
    this.enterRule(localctx, 116, LogoParser.RULE_power);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 493;
        this.match(LogoParser.T__92);
        this.state = 494;
        this.expression();
        this.state = 495;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Log10Context(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_log10;
    return this;
}

Log10Context.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Log10Context.prototype.constructor = Log10Context;

Log10Context.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

Log10Context.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterLog10(this);
	}
};

Log10Context.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitLog10(this);
	}
};

Log10Context.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitLog10(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.Log10Context = Log10Context;

LogoParser.prototype.log10 = function() {

    var localctx = new Log10Context(this, this._ctx, this.state);
    this.enterRule(localctx, 118, LogoParser.RULE_log10);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 497;
        _la = this._input.LA(1);
        if(!(_la===LogoParser.T__93 || _la===LogoParser.T__94)) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
        this.state = 498;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function WaiteContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_waite;
    return this;
}

WaiteContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
WaiteContext.prototype.constructor = WaiteContext;

WaiteContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

WaiteContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterWaite(this);
	}
};

WaiteContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitWaite(this);
	}
};

WaiteContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitWaite(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.WaiteContext = WaiteContext;

LogoParser.prototype.waite = function() {

    var localctx = new WaiteContext(this, this._ctx, this.state);
    this.enterRule(localctx, 120, LogoParser.RULE_waite);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 500;
        this.match(LogoParser.T__95);
        this.state = 501;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function WashContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_wash;
    return this;
}

WashContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
WashContext.prototype.constructor = WashContext;


WashContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterWash(this);
	}
};

WashContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitWash(this);
	}
};

WashContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitWash(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.WashContext = WashContext;

LogoParser.prototype.wash = function() {

    var localctx = new WashContext(this, this._ctx, this.state);
    this.enterRule(localctx, 122, LogoParser.RULE_wash);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 503;
        this.match(LogoParser.T__96);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SetpwContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_setpw;
    return this;
}

SetpwContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SetpwContext.prototype.constructor = SetpwContext;

SetpwContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

SetpwContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterSetpw(this);
	}
};

SetpwContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitSetpw(this);
	}
};

SetpwContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitSetpw(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.SetpwContext = SetpwContext;

LogoParser.prototype.setpw = function() {

    var localctx = new SetpwContext(this, this._ctx, this.state);
    this.enterRule(localctx, 124, LogoParser.RULE_setpw);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 505;
        _la = this._input.LA(1);
        if(!(_la===LogoParser.T__97 || _la===LogoParser.T__98)) {
        this._errHandler.recoverInline(this);
        }
        else {
            this.consume();
        }
        this.state = 506;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function CircleContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_circle;
    return this;
}

CircleContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
CircleContext.prototype.constructor = CircleContext;

CircleContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

CircleContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterCircle(this);
	}
};

CircleContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitCircle(this);
	}
};

CircleContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitCircle(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.CircleContext = CircleContext;

LogoParser.prototype.circle = function() {

    var localctx = new CircleContext(this, this._ctx, this.state);
    this.enterRule(localctx, 126, LogoParser.RULE_circle);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 508;
        this.match(LogoParser.T__99);
        this.state = 509;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SetheadingContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_setheading;
    return this;
}

SetheadingContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SetheadingContext.prototype.constructor = SetheadingContext;

SetheadingContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

SetheadingContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterSetheading(this);
	}
};

SetheadingContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitSetheading(this);
	}
};

SetheadingContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitSetheading(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.SetheadingContext = SetheadingContext;

LogoParser.prototype.setheading = function() {

    var localctx = new SetheadingContext(this, this._ctx, this.state);
    this.enterRule(localctx, 128, LogoParser.RULE_setheading);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 511;
        this.match(LogoParser.T__100);
        this.state = 512;
        this.expression();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function NumberContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_number;
    return this;
}

NumberContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
NumberContext.prototype.constructor = NumberContext;

NumberContext.prototype.NUMBER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LogoParser.NUMBER);
    } else {
        return this.getToken(LogoParser.NUMBER, i);
    }
};


NumberContext.prototype.pie = function() {
    return this.getTypedRuleContext(PieContext,0);
};

NumberContext.prototype.ee = function() {
    return this.getTypedRuleContext(EeContext,0);
};

NumberContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterNumber(this);
	}
};

NumberContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitNumber(this);
	}
};

NumberContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitNumber(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.NumberContext = NumberContext;

LogoParser.prototype.number = function() {

    var localctx = new NumberContext(this, this._ctx, this.state);
    this.enterRule(localctx, 130, LogoParser.RULE_number);
    try {
        this.state = 520;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,33,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 514;
            this.match(LogoParser.NUMBER);
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 515;
            this.match(LogoParser.NUMBER);
            this.state = 516;
            this.match(LogoParser.T__101);
            this.state = 517;
            this.match(LogoParser.NUMBER);
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 518;
            this.pie();
            break;

        case 4:
            this.enterOuterAlt(localctx, 4);
            this.state = 519;
            this.ee();
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function CommentContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_comment;
    return this;
}

CommentContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
CommentContext.prototype.constructor = CommentContext;

CommentContext.prototype.COMMENT = function() {
    return this.getToken(LogoParser.COMMENT, 0);
};

CommentContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterComment(this);
	}
};

CommentContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitComment(this);
	}
};

CommentContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitComment(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.CommentContext = CommentContext;

LogoParser.prototype.comment = function() {

    var localctx = new CommentContext(this, this._ctx, this.state);
    this.enterRule(localctx, 132, LogoParser.RULE_comment);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 522;
        this.match(LogoParser.COMMENT);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function PieContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_pie;
    return this;
}

PieContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
PieContext.prototype.constructor = PieContext;


PieContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterPie(this);
	}
};

PieContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitPie(this);
	}
};

PieContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitPie(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.PieContext = PieContext;

LogoParser.prototype.pie = function() {

    var localctx = new PieContext(this, this._ctx, this.state);
    this.enterRule(localctx, 134, LogoParser.RULE_pie);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 524;
        this.match(LogoParser.T__102);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function EeContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_ee;
    return this;
}

EeContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
EeContext.prototype.constructor = EeContext;


EeContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterEe(this);
	}
};

EeContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitEe(this);
	}
};

EeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitEe(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.EeContext = EeContext;

LogoParser.prototype.ee = function() {

    var localctx = new EeContext(this, this._ctx, this.state);
    this.enterRule(localctx, 136, LogoParser.RULE_ee);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 526;
        this.match(LogoParser.T__103);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function UnitTestContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_unitTest;
    return this;
}

UnitTestContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
UnitTestContext.prototype.constructor = UnitTestContext;


UnitTestContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterUnitTest(this);
	}
};

UnitTestContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitUnitTest(this);
	}
};

UnitTestContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitUnitTest(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.UnitTestContext = UnitTestContext;

LogoParser.prototype.unitTest = function() {

    var localctx = new UnitTestContext(this, this._ctx, this.state);
    this.enterRule(localctx, 138, LogoParser.RULE_unitTest);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 528;
        this.match(LogoParser.T__104);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function CreateTestCaseContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_createTestCase;
    return this;
}

CreateTestCaseContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
CreateTestCaseContext.prototype.constructor = CreateTestCaseContext;


CreateTestCaseContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterCreateTestCase(this);
	}
};

CreateTestCaseContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitCreateTestCase(this);
	}
};

CreateTestCaseContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitCreateTestCase(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.CreateTestCaseContext = CreateTestCaseContext;

LogoParser.prototype.createTestCase = function() {

    var localctx = new CreateTestCaseContext(this, this._ctx, this.state);
    this.enterRule(localctx, 140, LogoParser.RULE_createTestCase);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 530;
        this.match(LogoParser.T__105);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function GenerateSolutionsContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_generateSolutions;
    return this;
}

GenerateSolutionsContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
GenerateSolutionsContext.prototype.constructor = GenerateSolutionsContext;


GenerateSolutionsContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterGenerateSolutions(this);
	}
};

GenerateSolutionsContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitGenerateSolutions(this);
	}
};

GenerateSolutionsContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitGenerateSolutions(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.GenerateSolutionsContext = GenerateSolutionsContext;

LogoParser.prototype.generateSolutions = function() {

    var localctx = new GenerateSolutionsContext(this, this._ctx, this.state);
    this.enterRule(localctx, 142, LogoParser.RULE_generateSolutions);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 532;
        this.match(LogoParser.T__106);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function UnitTestBookContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LogoParser.RULE_unitTestBook;
    return this;
}

UnitTestBookContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
UnitTestBookContext.prototype.constructor = UnitTestBookContext;


UnitTestBookContext.prototype.enterRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.enterUnitTestBook(this);
	}
};

UnitTestBookContext.prototype.exitRule = function(listener) {
    if(listener instanceof LogoListener ) {
        listener.exitUnitTestBook(this);
	}
};

UnitTestBookContext.prototype.accept = function(visitor) {
    if ( visitor instanceof LogoVisitor ) {
        return visitor.visitUnitTestBook(this);
    } else {
        return visitor.visitChildren(this);
    }
};




LogoParser.UnitTestBookContext = UnitTestBookContext;

LogoParser.prototype.unitTestBook = function() {

    var localctx = new UnitTestBookContext(this, this._ctx, this.state);
    this.enterRule(localctx, 144, LogoParser.RULE_unitTestBook);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 534;
        this.match(LogoParser.T__107);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


exports.LogoParser = LogoParser;



//////////////////
// WEBPACK FOOTER
// ./src/app/interpreter/interpreter-input/LogoParser.js
// module id = ./src/app/interpreter/interpreter-input/LogoParser.js
// module chunks = main